(function (root, factory) {
  if (typeof define === 'function' && define.amd)
    define(['exports', '../core-core-api.js', '../kotlin-kotlin-stdlib.js', '../core-core-stl.js', '../core-core-range-dynamic-range.js', '../core-core-experimental.js', '../ipex-range-format.js', '../core-core-kernel.js', '../core-test-helpers.js'], factory);
  else if (typeof exports === 'object')
    factory(module.exports, require('../core-core-api.js'), require('../kotlin-kotlin-stdlib.js'), require('../core-core-stl.js'), require('../core-core-range-dynamic-range.js'), require('../core-core-experimental.js'), require('../ipex-range-format.js'), require('../core-core-kernel.js'), require('../core-test-helpers.js'));
  else {
    if (typeof this['core-core-api'] === 'undefined') {
      throw new Error("Error loading module 'core:core-js'. Its dependency 'core-core-api' was not found. Please, check whether 'core-core-api' is loaded prior to 'core:core-js'.");
    }
    if (typeof this['kotlin-kotlin-stdlib'] === 'undefined') {
      throw new Error("Error loading module 'core:core-js'. Its dependency 'kotlin-kotlin-stdlib' was not found. Please, check whether 'kotlin-kotlin-stdlib' is loaded prior to 'core:core-js'.");
    }
    if (typeof this['core-core-stl'] === 'undefined') {
      throw new Error("Error loading module 'core:core-js'. Its dependency 'core-core-stl' was not found. Please, check whether 'core-core-stl' is loaded prior to 'core:core-js'.");
    }
    if (typeof this['core-core-range-dynamic-range'] === 'undefined') {
      throw new Error("Error loading module 'core:core-js'. Its dependency 'core-core-range-dynamic-range' was not found. Please, check whether 'core-core-range-dynamic-range' is loaded prior to 'core:core-js'.");
    }
    if (typeof this['core-core-experimental'] === 'undefined') {
      throw new Error("Error loading module 'core:core-js'. Its dependency 'core-core-experimental' was not found. Please, check whether 'core-core-experimental' is loaded prior to 'core:core-js'.");
    }
    if (typeof this['ipex-range-format'] === 'undefined') {
      throw new Error("Error loading module 'core:core-js'. Its dependency 'ipex-range-format' was not found. Please, check whether 'ipex-range-format' is loaded prior to 'core:core-js'.");
    }
    if (typeof this['core-core-kernel'] === 'undefined') {
      throw new Error("Error loading module 'core:core-js'. Its dependency 'core-core-kernel' was not found. Please, check whether 'core-core-kernel' is loaded prior to 'core:core-js'.");
    }
    if (typeof this['core-test-helpers'] === 'undefined') {
      throw new Error("Error loading module 'core:core-js'. Its dependency 'core-test-helpers' was not found. Please, check whether 'core-test-helpers' is loaded prior to 'core:core-js'.");
    }
    root['core:core-js'] = factory(typeof this['core:core-js'] === 'undefined' ? {} : this['core:core-js'], this['core-core-api'], this['kotlin-kotlin-stdlib'], this['core-core-stl'], this['core-core-range-dynamic-range'], this['core-core-experimental'], this['ipex-range-format'], this['core-core-kernel'], this['core-test-helpers']);
  }
}(this, function (_, kotlin_core_core_api, kotlin_kotlin, kotlin_core_core_stl, kotlin_core_core_range_dynamic_range, kotlin_core_core_experimental, kotlin_core_ipex_range_format, kotlin_core_core_kernel, kotlin_core_core_test_test_helpers) {
  'use strict';
  //region block: imports
  var imul = Math.imul;
  var Companion_getInstance = kotlin_core_core_api.$_$.kb;
  var Degrees = kotlin_core_core_api.$_$.s4;
  var UnserializableEntityComponent = kotlin_core_core_api.$_$.q6;
  var protoOf = kotlin_kotlin.$_$.u9;
  var defineProp = kotlin_kotlin.$_$.s8;
  var classMeta = kotlin_kotlin.$_$.q8;
  var setMetadataFor = kotlin_kotlin.$_$.v9;
  var VOID = kotlin_kotlin.$_$.e;
  var valueOf = kotlin_core_core_api.$_$.p2;
  var LoadedModelInfoComponent = kotlin_core_core_api.$_$.n5;
  var Vector = kotlin_core_core_api.$_$.c5;
  var Margin = kotlin_core_core_api.$_$.t4;
  var Size = kotlin_core_core_api.$_$.a5;
  var ModelTransform = kotlin_core_core_api.$_$.u4;
  var EntityManagerImpl = kotlin_core_core_api.$_$.y2;
  var Ray = kotlin_core_core_api.$_$.m5;
  var Transform = kotlin_core_core_api.$_$.b5;
  var QuaternionFromDouble = kotlin_core_core_api.$_$.c9;
  var Radians = kotlin_core_core_api.$_$.x4;
  var Face = kotlin_core_core_api.$_$.t6;
  var CuboidFromSize = kotlin_core_core_api.$_$.f9;
  var PolyhedronGroup = kotlin_core_core_api.$_$.u6;
  var ConvexPolyhedron = kotlin_core_core_api.$_$.s6;
  var AxisAlignedBox = kotlin_core_core_api.$_$.r6;
  var ProductSpecification = kotlin_core_core_api.$_$.s;
  var ValidationResultFail = kotlin_core_core_api.$_$.u7;
  var ValidationResultWarning = kotlin_core_core_api.$_$.v7;
  var CollisionValidationResult = kotlin_core_core_api.$_$.z;
  var CollisionValidation = kotlin_core_core_api.$_$.a1;
  var PartPair = kotlin_core_core_api.$_$.j;
  var ColliderShapeComponent = kotlin_core_core_api.$_$.y;
  var Polygon = kotlin_core_core_api.$_$.w4;
  var Plane = kotlin_core_core_api.$_$.v4;
  var DebugSurfacesComponent = kotlin_core_core_api.$_$.m2;
  var DisplayNameComponent = kotlin_core_core_api.$_$.e5;
  var DisabledConnectorsComponent = kotlin_core_core_api.$_$.x1;
  var ModelInfoComponent = kotlin_core_core_api.$_$.o5;
  var ModelTransformComponent = kotlin_core_core_api.$_$.p5;
  var RelativeConnectorData = kotlin_core_core_api.$_$.c2;
  var RelationOriginAlongXImpostor_getInstance = kotlin_core_core_api.$_$.mb;
  var RelationOriginAlongYImpostor_getInstance = kotlin_core_core_api.$_$.nb;
  var RelationOriginAlongZImpostor_getInstance = kotlin_core_core_api.$_$.ob;
  var RelationOrigin = kotlin_core_core_api.$_$.y4;
  var RelativeBoxOffset = kotlin_core_core_api.$_$.z4;
  var PointConnector = kotlin_core_core_api.$_$.z1;
  var PointSeriesConnector = kotlin_core_core_api.$_$.a2;
  var PointSeriesSubConnector = kotlin_core_core_api.$_$.b2;
  var EdgeConnector = kotlin_core_core_api.$_$.y1;
  var SurfaceConnector = kotlin_core_core_api.$_$.g2;
  var ViewerDragEventComponent = kotlin_core_core_api.$_$.s2;
  var RaycastResult = kotlin_core_core_api.$_$.l5;
  var GuestConnectionsComponent = kotlin_core_core_api.$_$.m1;
  var HostConnectionsComponent = kotlin_core_core_api.$_$.n1;
  var DragSurfacesComponent = kotlin_core_core_api.$_$.n2;
  var OutlineableComponent = kotlin_core_core_api.$_$.q5;
  var DragSurface = kotlin_core_core_api.$_$.o2;
  var AutomaticGroupBuilderSystem = kotlin_core_core_api.$_$.f3;
  var ManualGroupConnectorValidation = kotlin_core_core_api.$_$.h3;
  var AssemblyStructureComponent = kotlin_core_core_api.$_$.i;
  var RestrictAllowedRequiredHostsComponent = kotlin_core_core_api.$_$.w6;
  var ManualEntityGroupBuilderService = kotlin_core_core_api.$_$.g3;
  var DebugLine = kotlin_core_core_api.$_$.l2;
  var DebugLinesComponent = kotlin_core_core_api.$_$.k2;
  var IsLoadingSnapshotComponent = kotlin_core_core_api.$_$.d7;
  var SnapshotIgnoreComponent = kotlin_core_core_api.$_$.e7;
  var ChildConnectionValidation = kotlin_core_core_api.$_$.j1;
  var ConnectorType_instance = kotlin_core_core_api.$_$.fa;
  var ProductCatalogFunctions_instance = kotlin_core_core_api.$_$.n9;
  var RelativeConnectorRepositioner_instance = kotlin_core_core_api.$_$.ja;
  var MathUtils_getInstance = kotlin_core_core_api.$_$.gb;
  var LogLevelJavascriptImpostor_instance = kotlin_core_core_api.$_$.eb;
  var RotationDegreeOfFreedomImpostor_instance = kotlin_core_core_api.$_$.ka;
  var PolyhedronUtils_getInstance = kotlin_core_core_api.$_$.qc;
  var ApiSystemIds_instance = kotlin_core_core_api.$_$.yc;
  var ValidationResultType_FAIL_getInstance = kotlin_core_core_api.$_$.n8;
  var ValidationResultType_WARNING_getInstance = kotlin_core_core_api.$_$.o8;
  var Companion_getInstance_0 = kotlin_core_core_api.$_$.pc;
  var VectorConstants_getInstance = kotlin_core_core_api.$_$.ub;
  var SelectedComponent_instance = kotlin_core_core_api.$_$.mc;
  var SceneReloadingComponent_instance = kotlin_core_core_api.$_$.nc;
  var RenderedComponent_instance = kotlin_core_core_api.$_$.fc;
  var InSceneComponent_instance = kotlin_core_core_api.$_$.ab;
  var StaticComponent_getInstance = kotlin_core_core_api.$_$.wa;
  var SelectableComponent = kotlin_core_core_api.$_$.f6;
  var DraggableComponent = kotlin_core_core_api.$_$.q2;
  var SnapRootComponent = kotlin_core_core_api.$_$.z6;
  var valueOf_0 = kotlin_core_core_api.$_$.k4;
  var HistoryChangedEventComponent = kotlin_core_core_api.$_$.j4;
  var WorldSpaceDragEventComponent = kotlin_core_core_api.$_$.u2;
  var ClickEventComponent = kotlin_core_core_api.$_$.e6;
  var LocalTransformComponent = kotlin_core_core_api.$_$.g7;
  var ConnectorsComponent = kotlin_core_core_api.$_$.u1;
  var ChildComponent = kotlin_core_core_api.$_$.j3;
  var ParentComponent = kotlin_core_core_api.$_$.m3;
  var ViewerObjectComponent = kotlin_core_core_api.$_$.u5;
  var ConnectionRootComponent = kotlin_core_core_api.$_$.k1;
  var ProductPartComponent = kotlin_core_core_api.$_$.k;
  var WorldTransformComponent = kotlin_core_core_api.$_$.i7;
  var TemplateDataComponent = kotlin_core_core_api.$_$.f5;
  var RelativeConnectorsComponent = kotlin_core_core_api.$_$.d2;
  var AssemblyPartsComponent_init_$Create$ = kotlin_core_core_api.$_$.b9;
  var ViewerComponent = kotlin_core_core_api.$_$.s5;
  var ProductComponent = kotlin_core_core_api.$_$.q;
  var HistoryEvent_instance = kotlin_core_core_api.$_$.db;
  var ComponentIds_instance = kotlin_core_core_api.$_$.w9;
  var ComponentIdSpan_instance = kotlin_core_core_api.$_$.v9;
  var DragSurfaceNormalVisualizationSystem = kotlin_core_core_stl.$_$.j1;
  var DrawDragGhostSystem = kotlin_core_core_stl.$_$.m1;
  var Measurer = kotlin_core_core_api.$_$.o7;
  var MeasuringEntityManagerWatcher = kotlin_core_core_stl.$_$.w;
  var PlacementService = kotlin_core_core_stl.$_$.h2;
  var Unit_instance = kotlin_kotlin.$_$.x3;
  var LinkedHashMap_init_$Create$ = kotlin_kotlin.$_$.q;
  var DefaultVisualizer = kotlin_core_core_stl.$_$.x3;
  var CoreVisualization = kotlin_core_core_stl.$_$.y3;
  var echoStandardConsole = kotlin_core_core_api.$_$.r4;
  var ArrayList_init_$Create$ = kotlin_kotlin.$_$.h;
  var copyToArray = kotlin_kotlin.$_$.l5;
  var get_displayName = kotlin_core_core_api.$_$.h5;
  var LoggingEntityManagerWatcher = kotlin_core_core_stl.$_$.v;
  var SnapUtils_instance = kotlin_core_core_api.$_$.vc;
  var SnapSettings = kotlin_core_core_api.$_$.a7;
  var Pair = kotlin_kotlin.$_$.yc;
  var mutableListOf = kotlin_kotlin.$_$.u6;
  var firstOrNull = kotlin_kotlin.$_$.t5;
  var getKClassFromExpression = kotlin_kotlin.$_$.c;
  var THROW_CCE = kotlin_kotlin.$_$.ad;
  var contentEquals = kotlin_kotlin.$_$.z4;
  var contentHashCode = kotlin_kotlin.$_$.a5;
  var toString = kotlin_kotlin.$_$.z9;
  var ColliderUtils_instance = kotlin_core_core_api.$_$.t9;
  var CollisionUtils_instance = kotlin_core_core_api.$_$.u9;
  var ComponentUtils_instance = kotlin_core_core_api.$_$.x9;
  var ConnectionUtils_instance = kotlin_core_core_api.$_$.aa;
  var ConnectorUtils_instance = kotlin_core_core_api.$_$.ga;
  var EntityGroupUtils_instance = kotlin_core_core_api.$_$.ua;
  var HierarchyUtils_instance = kotlin_core_core_api.$_$.za;
  var MeasurementUtils_getInstance = kotlin_core_core_api.$_$.vb;
  var ModelUtils_getInstance = kotlin_core_core_api.$_$.ec;
  var ProductUtils_instance = kotlin_core_core_api.$_$.wb;
  var RaycastUtils_instance = kotlin_core_core_api.$_$.ac;
  var SnapActionCandidateSortAndSelectStrategies_getInstance = kotlin_core_core_api.$_$.sc;
  var TransformUtils_instance = kotlin_core_core_api.$_$.cd;
  var DoorComponent_getInstance = kotlin_core_core_stl.$_$.q4;
  var FreeMoveComponent_instance = kotlin_core_core_stl.$_$.i4;
  var IsDraggedComponent_instance = kotlin_core_core_stl.$_$.j4;
  var RoomComponent_instance = kotlin_core_core_stl.$_$.y4;
  var OutlinedComponent = kotlin_core_core_stl.$_$.e2;
  var OutlineBlockingComponent = kotlin_core_core_stl.$_$.a2;
  var AutoAdaptHostComponent = kotlin_core_core_stl.$_$.l;
  var AutoAdaptGuestComponent = kotlin_core_core_stl.$_$.k;
  var AutoAdaptVariantComponent = kotlin_core_core_stl.$_$.m;
  var ForceAutoAdaptWhenParentIsDraggedComponent = kotlin_core_core_stl.$_$.n;
  var AllowedDoorPairsComponentFromArrays = kotlin_core_core_stl.$_$.z3;
  var AlignmentConnectionsComponent = kotlin_core_core_stl.$_$.b;
  var LightComponent = kotlin_core_core_stl.$_$.o2;
  var RoomDimensionsComponent = kotlin_core_core_stl.$_$.q2;
  var RoomPartComponent = kotlin_core_core_stl.$_$.r2;
  var Companion_getInstance_1 = kotlin_core_core_range_dynamic_range.$_$.y;
  var PositionValue = kotlin_core_core_range_dynamic_range.$_$.k;
  var OriginRelativeToImpostor_getInstance = kotlin_core_core_range_dynamic_range.$_$.x;
  var OriginTemplate = kotlin_core_core_range_dynamic_range.$_$.r;
  var DynamicProductCatalog = kotlin_core_core_range_dynamic_range.$_$.a;
  var DynamicProduct = kotlin_core_core_range_dynamic_range.$_$.b;
  var ProductTemplate = kotlin_core_core_range_dynamic_range.$_$.c;
  var CatalogTemplateData = kotlin_core_core_range_dynamic_range.$_$.f;
  var Part = kotlin_core_core_range_dynamic_range.$_$.h;
  var ModelRenderInfo = kotlin_core_core_range_dynamic_range.$_$.g;
  var RelativePosition = kotlin_core_core_range_dynamic_range.$_$.l;
  var RelativeTransform = kotlin_core_core_range_dynamic_range.$_$.m;
  var PositionTemplate = kotlin_core_core_range_dynamic_range.$_$.s;
  var VisualLightSourceComponent = kotlin_core_core_range_dynamic_range.$_$.e;
  var TemplateEditorService = kotlin_core_core_range_dynamic_range.$_$.i;
  var BoundItemTemplate = kotlin_core_core_range_dynamic_range.$_$.n;
  var Dimension = kotlin_core_core_range_dynamic_range.$_$.q;
  var Compartment = kotlin_core_core_range_dynamic_range.$_$.o;
  var CatalogGenerator = kotlin_core_core_range_dynamic_range.$_$.t;
  var Companion_getInstance_2 = kotlin_core_core_range_dynamic_range.$_$.e1;
  var PositionTypeImpostor_instance = kotlin_core_core_range_dynamic_range.$_$.z;
  var ExperimentalPlacementService = kotlin_core_core_experimental.$_$.c;
  var LegacyPlacementHelper = kotlin_core_core_experimental.$_$.a;
  var ValidatedSnap = kotlin_core_core_experimental.$_$.b;
  var objectMeta = kotlin_kotlin.$_$.t9;
  var IPEXRangeFormatCatalog = kotlin_core_ipex_range_format.$_$.c;
  var AmendableCatalog = kotlin_core_ipex_range_format.$_$.b;
  var RangeItemDTO = kotlin_core_ipex_range_format.$_$.d;
  var StaticComponentBuilder = kotlin_core_ipex_range_format.$_$.a;
  var println = kotlin_kotlin.$_$.h8;
  var CoreImpl = kotlin_core_core_kernel.$_$.a;
  var SceneSerializationUtil_instance = kotlin_core_core_kernel.$_$.b;
  var ValidDragStrategyResult = kotlin_core_core_stl.$_$.b1;
  var AutoAdaptDragStrategy = kotlin_core_core_stl.$_$.p;
  var HandleRotationSystem = kotlin_core_core_stl.$_$.d;
  var values = kotlin_core_core_api.$_$.m4;
  var DebugLogger = kotlin_core_core_stl.$_$.x1;
  var FunctionalZonesLocalToWorldSystem = kotlin_core_core_stl.$_$.t1;
  var SnapPlacementActor = kotlin_core_core_stl.$_$.k2;
  var ProppingSystem = kotlin_core_core_stl.$_$.m2;
  var ConnectorVisualizationSystem = kotlin_core_core_stl.$_$.s3;
  var ColliderVisualizationSystem = kotlin_core_core_stl.$_$.r3;
  var AutoAdaptHostZoneVisualizationSystem = kotlin_core_core_stl.$_$.n3;
  var FunctionalMarginVisualizationSystem = kotlin_core_core_stl.$_$.p3;
  var FunctionalZoneVisualizationSystem = kotlin_core_core_stl.$_$.q3;
  var DragProjectionPointVisualizationSystem = kotlin_core_core_stl.$_$.o3;
  var DragSystem = kotlin_core_core_stl.$_$.l1;
  var SnapCardinalDirectionsDragStrategy = kotlin_core_core_stl.$_$.y;
  var SnapClosestDragStrategy = kotlin_core_core_stl.$_$.z;
  var SnapClosestWithSubConnectorsDragStrategy = kotlin_core_core_stl.$_$.a1;
  var ResolveCollisionsDragStrategy = kotlin_core_core_stl.$_$.x;
  var DragSurfaceVisualizationSystem = kotlin_core_core_stl.$_$.k1;
  var DebugLineDrawingSystem = kotlin_core_core_stl.$_$.u;
  var StandardSelectionService = kotlin_core_core_stl.$_$.e3;
  var AutoAdaptService = kotlin_core_core_stl.$_$.s;
  var AlignmentConnectionCreationSystem = kotlin_core_core_stl.$_$.a;
  var RoomService = kotlin_core_core_stl.$_$.b3;
  var RoomSystem = kotlin_core_core_stl.$_$.s2;
  var RoomComponentDeserializer = kotlin_core_core_stl.$_$.u2;
  var StandardSelectionSystemFromCoreServices = kotlin_core_core_stl.$_$.c4;
  var OutlineSystem = kotlin_core_core_stl.$_$.d2;
  var OutlineSelectedSystem = kotlin_core_core_stl.$_$.c2;
  var OutlineEntityGroupDeselectSystem = kotlin_core_core_stl.$_$.b2;
  var AllowedDoorPairsValidation = kotlin_core_core_stl.$_$.h;
  var AlignmentPlane = kotlin_core_core_stl.$_$.c;
  var AllowedNumberOfChildrenOfTypeValidation = kotlin_core_core_stl.$_$.f3;
  var DisallowSeparateRequiredHostsValidation = kotlin_core_core_stl.$_$.g3;
  var AssemblyInstructionsServiceImpl = kotlin_core_core_stl.$_$.i;
  var ICFDataService = kotlin_core_core_stl.$_$.v1;
  var PlacementResult = kotlin_core_core_stl.$_$.g2;
  var FunctionalMarginValidation = kotlin_core_core_stl.$_$.r1;
  var PlacementZoneValidation = kotlin_core_core_stl.$_$.h3;
  var AlignmentLinesSystem = kotlin_core_core_stl.$_$.f;
  var FunctionalMarginSystem = kotlin_core_core_stl.$_$.q1;
  var FunctionalMarginShapeComponent = kotlin_core_core_stl.$_$.p1;
  var FunctionalMarginComponent = kotlin_core_core_stl.$_$.o1;
  var RecommendedInitialPositionFromFloorComponent = kotlin_core_core_stl.$_$.j2;
  var PlacementZoneByHeightComponent = kotlin_core_core_stl.$_$.i2;
  var ReplacePartResult = kotlin_core_core_stl.$_$.p2;
  var DragSurfaceOnlyRoomSelector = kotlin_core_core_stl.$_$.f1;
  var AnyDragSurfaceProjectorFromCoreServices = kotlin_core_core_stl.$_$.a4;
  var XYPlaneProjector = kotlin_core_core_stl.$_$.d1;
  var DragSurfaceCanHostSelector = kotlin_core_core_stl.$_$.e1;
  var DragSurfaceCanHostWithAutoAdaptSelector = kotlin_core_core_stl.$_$.q;
  var AutoAdaptProductSpecificationsSystem = kotlin_core_core_stl.$_$.r;
  var LegacyCanvasTo3DDragConverterSystem = kotlin_core_core_stl.$_$.g1;
  var CanvasTo3DDragConverterSystemFromCoreServices = kotlin_core_core_stl.$_$.b4;
  var EntityConnectorVisualizationSystem = kotlin_core_core_stl.$_$.v3;
  var EntityConnectorVisualizationComponent = kotlin_core_core_stl.$_$.m3;
  var Color = kotlin_core_core_stl.$_$.w3;
  var EntityColliderVisualizationSystem = kotlin_core_core_stl.$_$.t3;
  var EntityColliderVisualizationComponent = kotlin_core_core_stl.$_$.l3;
  var EntityCollisionVisualizationSystem = kotlin_core_core_stl.$_$.u3;
  var DecoratorComponent = kotlin_core_core_stl.$_$.k3;
  var ColoredOutlineSystem = kotlin_core_core_stl.$_$.z1;
  var ColoredOutlineComponent = kotlin_core_core_stl.$_$.y1;
  var AutoAdaptSessionComponent = kotlin_core_core_stl.$_$.j;
  var DragProjectionPointComponent = kotlin_core_core_stl.$_$.c1;
  var FunctionalZone = kotlin_core_core_stl.$_$.u1;
  var FunctionalZonesLocalComponent = kotlin_core_core_stl.$_$.s1;
  var DragState = kotlin_core_core_stl.$_$.i1;
  var DragStateComponent = kotlin_core_core_stl.$_$.h1;
  var ReplacedWithAutoAdaptEventComponent = kotlin_core_core_stl.$_$.o;
  var LabelComponent = kotlin_core_core_stl.$_$.w1;
  var HigherPriorityAlignmentPostProcess = kotlin_core_core_stl.$_$.n1;
  var RequiredConnectorsSatisfiedValidation = kotlin_core_core_stl.$_$.i3;
  var HostConnectorRotationValidation = kotlin_core_core_stl.$_$.e;
  var SnapSorterBuilder = kotlin_core_core_stl.$_$.f2;
  var ReplaceUtils_instance = kotlin_core_core_stl.$_$.x4;
  var ReplaceAssemblyPartUtils_getInstance = kotlin_core_core_stl.$_$.w4;
  var RoomConnectorConstants_getInstance = kotlin_core_core_stl.$_$.z4;
  var Companion_instance = kotlin_core_core_stl.$_$.m4;
  var StlSystemIds_instance = kotlin_core_core_stl.$_$.a5;
  var Companion_getInstance_3 = kotlin_core_core_stl.$_$.b5;
  var AutoAdaptFeature_instance = kotlin_core_core_stl.$_$.g4;
  var AutoAdaptUtils_getInstance = kotlin_core_core_stl.$_$.h4;
  var ValidationResultIds_instance = kotlin_core_core_stl.$_$.c5;
  var ValidationRuleIds_instance = kotlin_core_core_stl.$_$.d5;
  var PlacementHelper_getInstance = kotlin_core_core_stl.$_$.l4;
  var SpaceFinderUtils_getInstance = kotlin_core_core_stl.$_$.k4;
  var CountSystem = kotlin_core_core_test_test_helpers.$_$.a;
  var ArrangeExtensions_instance = kotlin_core_core_test_test_helpers.$_$.b;
  var PlacementExtensions_instance = kotlin_core_core_test_test_helpers.$_$.d;
  var AutoAdaptExtensions_instance = kotlin_core_core_test_test_helpers.$_$.c;
  var RoomGeneratorUtils_instance = kotlin_core_core_test_test_helpers.$_$.e;
  //endregion
  //region block: pre-declaration
  setMetadataFor(UnserializableEntityComponent_0, 'UnserializableEntityComponentJS', classMeta, UnserializableEntityComponent, VOID, UnserializableEntityComponent_0);
  setMetadataFor(_CoreDebug, 'CoreDebug', classMeta);
  setMetadataFor(SortedValidationResult, 'SortedValidationResult', classMeta);
  setMetadataFor(getMeta$result$1, VOID, classMeta);
  setMetadataFor(Experimental, 'experimental-js', objectMeta);
  setMetadataFor(ValidDragStrategyResult_0, 'ValidDragStrategyResultJS', classMeta, ValidDragStrategyResult);
  setMetadataFor(AutoAdaptDragStrategy_0, 'AutoAdaptDragStrategyHS', classMeta, AutoAdaptDragStrategy);
  setMetadataFor(FunctionalZonesLocalToWorldSystem_0, 'FunctionalZonesLocalToWorldSystemJs', classMeta, FunctionalZonesLocalToWorldSystem);
  //endregion
  function get_ConnectorType() {
    _init_properties_api_js_kt__ym3iu4();
    return connectorType;
  }
  var connectorType;
  function get_Vector() {
    _init_properties_api_js_kt__ym3iu4();
    return Vector_0;
  }
  var Vector_0;
  function get_Margin() {
    _init_properties_api_js_kt__ym3iu4();
    return Margin_0;
  }
  var Margin_0;
  function get_Size() {
    _init_properties_api_js_kt__ym3iu4();
    return Size_0;
  }
  var Size_0;
  function get_ModelTransform() {
    _init_properties_api_js_kt__ym3iu4();
    return modelTransform;
  }
  var modelTransform;
  function get_EntityManagerImpl() {
    _init_properties_api_js_kt__ym3iu4();
    return entityManagerConstructor;
  }
  var entityManagerConstructor;
  function get_Ray() {
    _init_properties_api_js_kt__ym3iu4();
    return ray;
  }
  var ray;
  function get_Transform() {
    _init_properties_api_js_kt__ym3iu4();
    return Transform_0;
  }
  var Transform_0;
  function get_Quaternion() {
    _init_properties_api_js_kt__ym3iu4();
    return quaternion;
  }
  var quaternion;
  function get_Degrees() {
    _init_properties_api_js_kt__ym3iu4();
    return degrees;
  }
  var degrees;
  function get_Radians() {
    _init_properties_api_js_kt__ym3iu4();
    return radians;
  }
  var radians;
  function get_Face() {
    _init_properties_api_js_kt__ym3iu4();
    return Face_0;
  }
  var Face_0;
  function get_Cuboid() {
    _init_properties_api_js_kt__ym3iu4();
    return Cuboid;
  }
  var Cuboid;
  function get_PolyhedronGroup() {
    _init_properties_api_js_kt__ym3iu4();
    return PolyhedronGroup_0;
  }
  var PolyhedronGroup_0;
  function get_ConvexPolyhedron() {
    _init_properties_api_js_kt__ym3iu4();
    return ConvexPolyhedron_0;
  }
  var ConvexPolyhedron_0;
  function get_AxisAlignedBox() {
    _init_properties_api_js_kt__ym3iu4();
    return axisAlignedBox;
  }
  var axisAlignedBox;
  function get_ProductSpecification() {
    _init_properties_api_js_kt__ym3iu4();
    return ProductSpecification_0;
  }
  var ProductSpecification_0;
  function get_ValidationResultFail() {
    _init_properties_api_js_kt__ym3iu4();
    return ValidationResultFail_0;
  }
  var ValidationResultFail_0;
  function get_ValidationResultWarning() {
    _init_properties_api_js_kt__ym3iu4();
    return ValidationResultWarning_0;
  }
  var ValidationResultWarning_0;
  function get_CollisionValidationResult() {
    _init_properties_api_js_kt__ym3iu4();
    return CollisionValidationResult_0;
  }
  var CollisionValidationResult_0;
  function get_CollisionValidation() {
    _init_properties_api_js_kt__ym3iu4();
    return CollisionValidation_0;
  }
  var CollisionValidation_0;
  function get_PartPair() {
    _init_properties_api_js_kt__ym3iu4();
    return PartPair_0;
  }
  var PartPair_0;
  function get_ProductCatalogFunctions() {
    _init_properties_api_js_kt__ym3iu4();
    return ProductCatalogFunctions;
  }
  var ProductCatalogFunctions;
  function get_ColliderShapeComponent() {
    _init_properties_api_js_kt__ym3iu4();
    return ColliderShapeComponentConstructor;
  }
  var ColliderShapeComponentConstructor;
  function get_Polygon() {
    _init_properties_api_js_kt__ym3iu4();
    return Polygon_0;
  }
  var Polygon_0;
  function get_Plane() {
    _init_properties_api_js_kt__ym3iu4();
    return Plane_0;
  }
  var Plane_0;
  function get_DebugSurfacesComponent() {
    _init_properties_api_js_kt__ym3iu4();
    return DebugSurfacesComponent_0;
  }
  var DebugSurfacesComponent_0;
  function get_DisplayNameComponent() {
    _init_properties_api_js_kt__ym3iu4();
    return DisplayNameComponentConstructor;
  }
  var DisplayNameComponentConstructor;
  function get_DisabledConnectorsComponent() {
    _init_properties_api_js_kt__ym3iu4();
    return DisabledConnectorsComponentConstructor;
  }
  var DisabledConnectorsComponentConstructor;
  function get_ModelInfoComponent() {
    _init_properties_api_js_kt__ym3iu4();
    return modelInfoComponent;
  }
  var modelInfoComponent;
  function get_ModelTransformComponent() {
    _init_properties_api_js_kt__ym3iu4();
    return modelTransformComponent;
  }
  var modelTransformComponent;
  function get_RelativeConnectorRepositioner() {
    _init_properties_api_js_kt__ym3iu4();
    return RelativeConnectorRepositionerRef;
  }
  var RelativeConnectorRepositionerRef;
  function get_RelativeConnectorData() {
    _init_properties_api_js_kt__ym3iu4();
    return relativeConnectorData;
  }
  var relativeConnectorData;
  function get_RelationOriginAlongX() {
    _init_properties_api_js_kt__ym3iu4();
    return relationOriginAlongX;
  }
  var relationOriginAlongX;
  function get_RelationOriginAlongY() {
    _init_properties_api_js_kt__ym3iu4();
    return relationOriginAlongY;
  }
  var relationOriginAlongY;
  function get_RelationOriginAlongZ() {
    _init_properties_api_js_kt__ym3iu4();
    return relationOriginAlongZ;
  }
  var relationOriginAlongZ;
  function get_RelationOrigin() {
    _init_properties_api_js_kt__ym3iu4();
    return relationOrigin;
  }
  var relationOrigin;
  function get_RelativeBoxOffset() {
    _init_properties_api_js_kt__ym3iu4();
    return relativeBoxOffset;
  }
  var relativeBoxOffset;
  function get_PointConnector() {
    _init_properties_api_js_kt__ym3iu4();
    return PointConnector_0;
  }
  var PointConnector_0;
  function get_PointSeriesConnector() {
    _init_properties_api_js_kt__ym3iu4();
    return PointSeriesConnectorConstructor;
  }
  var PointSeriesConnectorConstructor;
  function get_PointSeriesSubConnector() {
    _init_properties_api_js_kt__ym3iu4();
    return PointSeriesSubconnector;
  }
  var PointSeriesSubconnector;
  function get_EdgeConnector() {
    _init_properties_api_js_kt__ym3iu4();
    return EdgeConnector_0;
  }
  var EdgeConnector_0;
  function get_SurfaceConnector() {
    _init_properties_api_js_kt__ym3iu4();
    return SurfaceConnector_0;
  }
  var SurfaceConnector_0;
  function get_MathUtils() {
    _init_properties_api_js_kt__ym3iu4();
    return MathUtilsRef;
  }
  var MathUtilsRef;
  function get_ViewerDragEventComponent() {
    _init_properties_api_js_kt__ym3iu4();
    return ViewerDragEventComponent_0;
  }
  var ViewerDragEventComponent_0;
  function get_LogLevel() {
    _init_properties_api_js_kt__ym3iu4();
    return logLevel;
  }
  var logLevel;
  function get_RotationDegreeOfFreedom() {
    _init_properties_api_js_kt__ym3iu4();
    return rotationDegreeOfFreedom;
  }
  var rotationDegreeOfFreedom;
  function get_PolyhedronUtils() {
    _init_properties_api_js_kt__ym3iu4();
    return PolyhedronUtilsRef;
  }
  var PolyhedronUtilsRef;
  function get_RaycastResult() {
    _init_properties_api_js_kt__ym3iu4();
    return RaycastResult_0;
  }
  var RaycastResult_0;
  function get_ApiSystemIds() {
    _init_properties_api_js_kt__ym3iu4();
    return apiSystemIds;
  }
  var apiSystemIds;
  function get_GuestConnectionsComponent() {
    _init_properties_api_js_kt__ym3iu4();
    return guestConnectionsComponentConstructor;
  }
  var guestConnectionsComponentConstructor;
  function get_HostConnectionsComponent() {
    _init_properties_api_js_kt__ym3iu4();
    return HostConnectionsComponentConstructor;
  }
  var HostConnectionsComponentConstructor;
  function get_DragSurfacesComponent() {
    _init_properties_api_js_kt__ym3iu4();
    return dragSurfacesComponent;
  }
  var dragSurfacesComponent;
  function get_OutlineableComponent() {
    _init_properties_api_js_kt__ym3iu4();
    return outlineable;
  }
  var outlineable;
  function get_DragSurface() {
    _init_properties_api_js_kt__ym3iu4();
    return dragSurface;
  }
  var dragSurface;
  function get_AutomaticGroupBuilderSystem() {
    _init_properties_api_js_kt__ym3iu4();
    return automaticEntityGroupBuilderSystemConstructor;
  }
  var automaticEntityGroupBuilderSystemConstructor;
  function get_ManualGroupConnectorValidation() {
    _init_properties_api_js_kt__ym3iu4();
    return entityGroupConnectorValidation;
  }
  var entityGroupConnectorValidation;
  function get_AssemblyStructureComponent() {
    _init_properties_api_js_kt__ym3iu4();
    return assemblyStructureComponentConstructor;
  }
  var assemblyStructureComponentConstructor;
  function get_RestrictAllowedRequiredHostsComponent() {
    _init_properties_api_js_kt__ym3iu4();
    return RestrictAllowedRequiredHostsComponent_0;
  }
  var RestrictAllowedRequiredHostsComponent_0;
  function get_ManualEntityGroupBuilderService() {
    _init_properties_api_js_kt__ym3iu4();
    return ManualEntityGroupBuilderServiceConstructor;
  }
  var ManualEntityGroupBuilderServiceConstructor;
  function get_DebugLine() {
    _init_properties_api_js_kt__ym3iu4();
    return DebugLine_0;
  }
  var DebugLine_0;
  function get_DebugLinesComponent() {
    _init_properties_api_js_kt__ym3iu4();
    return DebugLinesComponent_0;
  }
  var DebugLinesComponent_0;
  function get_ValidationFail() {
    _init_properties_api_js_kt__ym3iu4();
    return validationFail;
  }
  var validationFail;
  function get_ValidationWarning() {
    _init_properties_api_js_kt__ym3iu4();
    return validationWarning;
  }
  var validationWarning;
  function get_AxisAlignedBoxUtils() {
    _init_properties_api_js_kt__ym3iu4();
    return AxisAlignedBoxUtils;
  }
  var AxisAlignedBoxUtils;
  function get_VectorConstants() {
    _init_properties_api_js_kt__ym3iu4();
    return VectorConstantsRef;
  }
  var VectorConstantsRef;
  function get_IsLoadingSnapshotComponent() {
    _init_properties_api_js_kt__ym3iu4();
    return isLoadingSnapshotComponent;
  }
  var isLoadingSnapshotComponent;
  function get_SnapshotIgnoreComponent() {
    _init_properties_api_js_kt__ym3iu4();
    return snapshotIgnoreComponent;
  }
  var snapshotIgnoreComponent;
  function get_ChildConnectionValidation() {
    _init_properties_api_js_kt__ym3iu4();
    return childConnectionValidation;
  }
  var childConnectionValidation;
  function quaternionFromEuler(x, y, z) {
    _init_properties_api_js_kt__ym3iu4();
    return Companion_getInstance().fromEulerDegrees(new Degrees(x), new Degrees(y), new Degrees(z));
  }
  function UnserializableEntityComponent_0() {
    UnserializableEntityComponent.call(this);
  }
  function createDragType(type) {
    _init_properties_api_js_kt__ym3iu4();
    return valueOf(type);
  }
  function mockLoadedModelInfoComponent(hasFinishedLoading) {
    _init_properties_api_js_kt__ym3iu4();
    return new LoadedModelInfoComponent(hasFinishedLoading);
  }
  function Vector$_init_$ref_b2yate() {
    var l = function (p0, p1, p2) {
      return new Vector(p0, p1, p2);
    };
    l.callableName = '<init>';
    return l;
  }
  function Margin$_init_$ref_8haia1() {
    var l = function (p0, p1, p2, p3, p4, p5) {
      return new Margin(p0, p1, p2, p3, p4, p5);
    };
    l.callableName = '<init>';
    return l;
  }
  function Size$_init_$ref_sdxags() {
    var l = function (p0, p1, p2) {
      return new Size(p0, p1, p2);
    };
    l.callableName = '<init>';
    return l;
  }
  function ModelTransform$_init_$ref_dirtfi() {
    var l = function (p0, p1, p2) {
      return new ModelTransform(p0, p1, p2);
    };
    l.callableName = '<init>';
    return l;
  }
  function EntityManagerImpl$_init_$ref_tnm1nf() {
    var l = function (p0) {
      return new EntityManagerImpl(p0);
    };
    l.callableName = '<init>';
    return l;
  }
  function Ray$_init_$ref_ybpkqj() {
    var l = function (p0, p1) {
      return new Ray(p0, p1);
    };
    l.callableName = '<init>';
    return l;
  }
  function Transform$_init_$ref_t8t60p() {
    var l = function (p0, p1) {
      return new Transform(p0, p1);
    };
    l.callableName = '<init>';
    return l;
  }
  function Quaternion$_init_$ref_fnu1zb() {
    var l = function (p0, p1, p2, p3) {
      return QuaternionFromDouble(p0, p1, p2, p3);
    };
    l.callableName = '<init>';
    return l;
  }
  function Degrees$_init_$ref_s8ngf6() {
    var l = function (p0) {
      return new Degrees(p0);
    };
    l.callableName = '<init>';
    return l;
  }
  function Radians$_init_$ref_ac71tf() {
    var l = function (p0) {
      return new Radians(p0);
    };
    l.callableName = '<init>';
    return l;
  }
  function Face$_init_$ref_vy87x4() {
    var l = function (p0) {
      return new Face(p0);
    };
    l.callableName = '<init>';
    return l;
  }
  function Cuboid$_init_$ref_z3blhn() {
    var l = function (p0) {
      return CuboidFromSize(p0);
    };
    l.callableName = '<init>';
    return l;
  }
  function PolyhedronGroup$_init_$ref_9q1lgk() {
    var l = function (p0) {
      return new PolyhedronGroup(p0);
    };
    l.callableName = '<init>';
    return l;
  }
  function ConvexPolyhedron$_init_$ref_ukuqx4() {
    var l = function (p0, p1, p2, p3) {
      return new ConvexPolyhedron(p0, p1, p2, p3);
    };
    l.callableName = '<init>';
    return l;
  }
  function AxisAlignedBox$_init_$ref_3ik1el() {
    var l = function (p0, p1) {
      return new AxisAlignedBox(p0, p1);
    };
    l.callableName = '<init>';
    return l;
  }
  function ProductSpecification$_init_$ref_co9ifl() {
    var l = function (p0) {
      return new ProductSpecification(p0);
    };
    l.callableName = '<init>';
    return l;
  }
  function ValidationResultFail$_init_$ref_33hbjl() {
    var l = function (p0, p1, p2) {
      return new ValidationResultFail(p0, p1, p2);
    };
    l.callableName = '<init>';
    return l;
  }
  function ValidationResultWarning$_init_$ref_ifhc0v() {
    var l = function (p0, p1, p2) {
      return new ValidationResultWarning(p0, p1, p2);
    };
    l.callableName = '<init>';
    return l;
  }
  function CollisionValidationResult$_init_$ref_9xprc3() {
    var l = function (p0, p1, p2, p3) {
      return new CollisionValidationResult(p0, p1, p2, p3);
    };
    l.callableName = '<init>';
    return l;
  }
  function CollisionValidation$_init_$ref_6atbwm() {
    var l = function () {
      return new CollisionValidation();
    };
    l.callableName = '<init>';
    return l;
  }
  function PartPair$_init_$ref_5c2u5k() {
    var l = function (p0, p1) {
      return new PartPair(p0, p1);
    };
    l.callableName = '<init>';
    return l;
  }
  function ColliderShapeComponent$_init_$ref_8mmz1x() {
    var l = function (p0, p1) {
      return new ColliderShapeComponent(p0, p1);
    };
    l.callableName = '<init>';
    return l;
  }
  function Polygon$_init_$ref_gy2pcl() {
    var l = function (p0, p1) {
      return new Polygon(p0, p1);
    };
    l.callableName = '<init>';
    return l;
  }
  function Plane$_init_$ref_qgmgjb() {
    var l = function (p0, p1) {
      return new Plane(p0, p1);
    };
    l.callableName = '<init>';
    return l;
  }
  function DebugSurfacesComponent$_init_$ref_cixmtd() {
    var l = function (p0) {
      return new DebugSurfacesComponent(p0);
    };
    l.callableName = '<init>';
    return l;
  }
  function DisplayNameComponent$_init_$ref_oabmi3() {
    var l = function (p0) {
      return new DisplayNameComponent(p0);
    };
    l.callableName = '<init>';
    return l;
  }
  function DisabledConnectorsComponent$_init_$ref_9lx7na() {
    var l = function (p0) {
      return new DisabledConnectorsComponent(p0);
    };
    l.callableName = '<init>';
    return l;
  }
  function ModelInfoComponent$_init_$ref_4c9uw1() {
    var l = function (p0, p1, p2) {
      return new ModelInfoComponent(p0, p1, p2);
    };
    l.callableName = '<init>';
    return l;
  }
  function ModelTransformComponent$_init_$ref_qm70d1() {
    var l = function (p0) {
      return new ModelTransformComponent(p0);
    };
    l.callableName = '<init>';
    return l;
  }
  function RelativeConnectorData$_init_$ref_gl5e92() {
    var l = function (p0, p1) {
      return new RelativeConnectorData(p0, p1);
    };
    l.callableName = '<init>';
    return l;
  }
  function relationOrigin$lambda(x, y, z) {
    _init_properties_api_js_kt__ym3iu4();
    return new RelationOrigin(RelationOriginAlongXImpostor_getInstance().toEnum(x), RelationOriginAlongYImpostor_getInstance().toEnum(y), RelationOriginAlongZImpostor_getInstance().toEnum(z));
  }
  function RelativeBoxOffset$_init_$ref_c5ral() {
    var l = function (p0, p1) {
      return new RelativeBoxOffset(p0, p1);
    };
    l.callableName = '<init>';
    return l;
  }
  function PointConnector$_init_$ref_zf7wyw() {
    var l = function (p0, p1, p2, p3, p4, p5, p6, p7, p8, p9, p10, p11) {
      return new PointConnector(p0, p1, p2, p3, p4, p5, p6, p7, p8, p9, p10, p11);
    };
    l.callableName = '<init>';
    return l;
  }
  function PointSeriesConnector$_init_$ref_nsfidb() {
    var l = function (p0, p1, p2, p3, p4, p5, p6, p7, p8, p9, p10, p11, p12, p13) {
      return new PointSeriesConnector(p0, p1, p2, p3, p4, p5, p6, p7, p8, p9, p10, p11, p12, p13);
    };
    l.callableName = '<init>';
    return l;
  }
  function PointSeriesSubConnector$_init_$ref_dzni41() {
    var l = function (p0, p1) {
      return new PointSeriesSubConnector(p0, p1);
    };
    l.callableName = '<init>';
    return l;
  }
  function EdgeConnector$_init_$ref_1gnl2j() {
    var l = function (p0, p1, p2, p3, p4, p5, p6, p7, p8, p9, p10, p11) {
      return new EdgeConnector(p0, p1, p2, p3, p4, p5, p6, p7, p8, p9, p10, p11);
    };
    l.callableName = '<init>';
    return l;
  }
  function SurfaceConnector$_init_$ref_f5mxff() {
    var l = function (p0, p1, p2, p3, p4, p5, p6, p7, p8, p9) {
      return new SurfaceConnector(p0, p1, p2, p3, p4, p5, p6, p7, p8, p9);
    };
    l.callableName = '<init>';
    return l;
  }
  function ViewerDragEventComponent$_init_$ref_frd03o() {
    var l = function (p0, p1, p2, p3) {
      return new ViewerDragEventComponent(p0, p1, p2, p3);
    };
    l.callableName = '<init>';
    return l;
  }
  function RaycastResult$_init_$ref_cau7en() {
    var l = function (p0, p1) {
      return new RaycastResult(p0, p1);
    };
    l.callableName = '<init>';
    return l;
  }
  function GuestConnectionsComponent$_init_$ref_fpjczp() {
    var l = function (p0) {
      return new GuestConnectionsComponent(p0);
    };
    l.callableName = '<init>';
    return l;
  }
  function HostConnectionsComponent$_init_$ref_klemph() {
    var l = function (p0) {
      return new HostConnectionsComponent(p0);
    };
    l.callableName = '<init>';
    return l;
  }
  function DragSurfacesComponent$_init_$ref_vthysi() {
    var l = function (p0, p1) {
      return new DragSurfacesComponent(p0, p1);
    };
    l.callableName = '<init>';
    return l;
  }
  function OutlineableComponent$_init_$ref_vzlam4() {
    var l = function () {
      return new OutlineableComponent();
    };
    l.callableName = '<init>';
    return l;
  }
  function DragSurface$_init_$ref_mad784() {
    var l = function (p0, p1) {
      return new DragSurface(p0, p1);
    };
    l.callableName = '<init>';
    return l;
  }
  function AutomaticGroupBuilderSystem$_init_$ref_3dadxt() {
    var l = function (p0) {
      return new AutomaticGroupBuilderSystem(p0);
    };
    l.callableName = '<init>';
    return l;
  }
  function ManualGroupConnectorValidation$_init_$ref_fsugfs() {
    var l = function (p0, p1) {
      return new ManualGroupConnectorValidation(p0, p1);
    };
    l.callableName = '<init>';
    return l;
  }
  function AssemblyStructureComponent$_init_$ref_ghd23v() {
    var l = function (p0) {
      return new AssemblyStructureComponent(p0);
    };
    l.callableName = '<init>';
    return l;
  }
  function RestrictAllowedRequiredHostsComponent$_init_$ref_wx7v88() {
    var l = function (p0) {
      return new RestrictAllowedRequiredHostsComponent(p0);
    };
    l.callableName = '<init>';
    return l;
  }
  function ManualEntityGroupBuilderService$_init_$ref_e8eyt1() {
    var l = function (p0, p1) {
      return new ManualEntityGroupBuilderService(p0, p1);
    };
    l.callableName = '<init>';
    return l;
  }
  function DebugLine$_init_$ref_z9a10i() {
    var l = function (p0, p1, p2, p3) {
      return new DebugLine(p0, p1, p2, p3);
    };
    l.callableName = '<init>';
    return l;
  }
  function DebugLinesComponent$_init_$ref_gfcjdg() {
    var l = function (p0) {
      return new DebugLinesComponent(p0);
    };
    l.callableName = '<init>';
    return l;
  }
  function IsLoadingSnapshotComponent$_init_$ref_igs8ou() {
    var l = function () {
      return new IsLoadingSnapshotComponent();
    };
    l.callableName = '<init>';
    return l;
  }
  function SnapshotIgnoreComponent$_init_$ref_uxdxnm() {
    var l = function () {
      return new SnapshotIgnoreComponent();
    };
    l.callableName = '<init>';
    return l;
  }
  function ChildConnectionValidation$_init_$ref_m19sa6() {
    var l = function () {
      return new ChildConnectionValidation();
    };
    l.callableName = '<init>';
    return l;
  }
  var properties_initialized_api_js_kt_m1n5xa;
  function _init_properties_api_js_kt__ym3iu4() {
    if (!properties_initialized_api_js_kt_m1n5xa) {
      properties_initialized_api_js_kt_m1n5xa = true;
      connectorType = ConnectorType_instance;
      Vector_0 = Vector$_init_$ref_b2yate();
      Margin_0 = Margin$_init_$ref_8haia1();
      Size_0 = Size$_init_$ref_sdxags();
      modelTransform = ModelTransform$_init_$ref_dirtfi();
      entityManagerConstructor = EntityManagerImpl$_init_$ref_tnm1nf();
      ray = Ray$_init_$ref_ybpkqj();
      Transform_0 = Transform$_init_$ref_t8t60p();
      quaternion = Quaternion$_init_$ref_fnu1zb();
      degrees = Degrees$_init_$ref_s8ngf6();
      radians = Radians$_init_$ref_ac71tf();
      Face_0 = Face$_init_$ref_vy87x4();
      Cuboid = Cuboid$_init_$ref_z3blhn();
      PolyhedronGroup_0 = PolyhedronGroup$_init_$ref_9q1lgk();
      ConvexPolyhedron_0 = ConvexPolyhedron$_init_$ref_ukuqx4();
      axisAlignedBox = AxisAlignedBox$_init_$ref_3ik1el();
      ProductSpecification_0 = ProductSpecification$_init_$ref_co9ifl();
      ValidationResultFail_0 = ValidationResultFail$_init_$ref_33hbjl();
      ValidationResultWarning_0 = ValidationResultWarning$_init_$ref_ifhc0v();
      CollisionValidationResult_0 = CollisionValidationResult$_init_$ref_9xprc3();
      CollisionValidation_0 = CollisionValidation$_init_$ref_6atbwm();
      PartPair_0 = PartPair$_init_$ref_5c2u5k();
      ProductCatalogFunctions = ProductCatalogFunctions_instance;
      ColliderShapeComponentConstructor = ColliderShapeComponent$_init_$ref_8mmz1x();
      Polygon_0 = Polygon$_init_$ref_gy2pcl();
      Plane_0 = Plane$_init_$ref_qgmgjb();
      DebugSurfacesComponent_0 = DebugSurfacesComponent$_init_$ref_cixmtd();
      DisplayNameComponentConstructor = DisplayNameComponent$_init_$ref_oabmi3();
      DisabledConnectorsComponentConstructor = DisabledConnectorsComponent$_init_$ref_9lx7na();
      modelInfoComponent = ModelInfoComponent$_init_$ref_4c9uw1();
      modelTransformComponent = ModelTransformComponent$_init_$ref_qm70d1();
      RelativeConnectorRepositionerRef = RelativeConnectorRepositioner_instance;
      relativeConnectorData = RelativeConnectorData$_init_$ref_gl5e92();
      relationOriginAlongX = RelationOriginAlongXImpostor_getInstance();
      relationOriginAlongY = RelationOriginAlongYImpostor_getInstance();
      relationOriginAlongZ = RelationOriginAlongZImpostor_getInstance();
      relationOrigin = relationOrigin$lambda;
      relativeBoxOffset = RelativeBoxOffset$_init_$ref_c5ral();
      PointConnector_0 = PointConnector$_init_$ref_zf7wyw();
      PointSeriesConnectorConstructor = PointSeriesConnector$_init_$ref_nsfidb();
      PointSeriesSubconnector = PointSeriesSubConnector$_init_$ref_dzni41();
      EdgeConnector_0 = EdgeConnector$_init_$ref_1gnl2j();
      SurfaceConnector_0 = SurfaceConnector$_init_$ref_f5mxff();
      MathUtilsRef = MathUtils_getInstance();
      ViewerDragEventComponent_0 = ViewerDragEventComponent$_init_$ref_frd03o();
      logLevel = LogLevelJavascriptImpostor_instance;
      rotationDegreeOfFreedom = RotationDegreeOfFreedomImpostor_instance;
      PolyhedronUtilsRef = PolyhedronUtils_getInstance();
      RaycastResult_0 = RaycastResult$_init_$ref_cau7en();
      apiSystemIds = ApiSystemIds_instance;
      guestConnectionsComponentConstructor = GuestConnectionsComponent$_init_$ref_fpjczp();
      HostConnectionsComponentConstructor = HostConnectionsComponent$_init_$ref_klemph();
      dragSurfacesComponent = DragSurfacesComponent$_init_$ref_vthysi();
      outlineable = OutlineableComponent$_init_$ref_vzlam4();
      dragSurface = DragSurface$_init_$ref_mad784();
      automaticEntityGroupBuilderSystemConstructor = AutomaticGroupBuilderSystem$_init_$ref_3dadxt();
      entityGroupConnectorValidation = ManualGroupConnectorValidation$_init_$ref_fsugfs();
      assemblyStructureComponentConstructor = AssemblyStructureComponent$_init_$ref_ghd23v();
      RestrictAllowedRequiredHostsComponent_0 = RestrictAllowedRequiredHostsComponent$_init_$ref_wx7v88();
      ManualEntityGroupBuilderServiceConstructor = ManualEntityGroupBuilderService$_init_$ref_e8eyt1();
      DebugLine_0 = DebugLine$_init_$ref_z9a10i();
      DebugLinesComponent_0 = DebugLinesComponent$_init_$ref_gfcjdg();
      validationFail = ValidationResultType_FAIL_getInstance();
      validationWarning = ValidationResultType_WARNING_getInstance();
      AxisAlignedBoxUtils = Companion_getInstance_0();
      VectorConstantsRef = VectorConstants_getInstance();
      isLoadingSnapshotComponent = IsLoadingSnapshotComponent$_init_$ref_igs8ou();
      snapshotIgnoreComponent = SnapshotIgnoreComponent$_init_$ref_uxdxnm();
      childConnectionValidation = ChildConnectionValidation$_init_$ref_m19sa6();
    }
  }
  function get_SelectableComponent() {
    _init_properties_component_kt__lifbkl();
    return selectable;
  }
  var selectable;
  function get_DraggableComponent() {
    _init_properties_component_kt__lifbkl();
    return draggable;
  }
  var draggable;
  function get_SnapRootComponent() {
    _init_properties_component_kt__lifbkl();
    return snapRootComponent;
  }
  var snapRootComponent;
  function get_HistoryEvent() {
    _init_properties_component_kt__lifbkl();
    return HistoryEvent;
  }
  var HistoryEvent;
  function get_HistoryChangedEventComponent() {
    _init_properties_component_kt__lifbkl();
    return historyChangedEventComponent;
  }
  var historyChangedEventComponent;
  function get_WorldSpaceDragEventComponent() {
    _init_properties_component_kt__lifbkl();
    return worldSpaceDragEventComponent;
  }
  var worldSpaceDragEventComponent;
  function get_ClickEventComponent() {
    _init_properties_component_kt__lifbkl();
    return clickEventComponent;
  }
  var clickEventComponent;
  function get_LocalTransformComponent() {
    _init_properties_component_kt__lifbkl();
    return localTransformation;
  }
  var localTransformation;
  function get_ConnectorsComponent() {
    _init_properties_component_kt__lifbkl();
    return connectorsComponent;
  }
  var connectorsComponent;
  function get_ChildComponent() {
    _init_properties_component_kt__lifbkl();
    return childComponent;
  }
  var childComponent;
  function get_ParentComponent() {
    _init_properties_component_kt__lifbkl();
    return parentComponent;
  }
  var parentComponent;
  function get_ViewerObjectComponent() {
    _init_properties_component_kt__lifbkl();
    return viewerObjectComponent;
  }
  var viewerObjectComponent;
  function get_ConnectionRootComponent() {
    _init_properties_component_kt__lifbkl();
    return connectionRootComponent;
  }
  var connectionRootComponent;
  function get_ProductPartComponent() {
    _init_properties_component_kt__lifbkl();
    return productPartComponent;
  }
  var productPartComponent;
  function get_WorldTransformComponent() {
    _init_properties_component_kt__lifbkl();
    return worldTransformComponent;
  }
  var worldTransformComponent;
  function get_ComponentIds() {
    _init_properties_component_kt__lifbkl();
    return componentIds;
  }
  var componentIds;
  function get_ComponentIdSpan() {
    _init_properties_component_kt__lifbkl();
    return componentIdSpan;
  }
  var componentIdSpan;
  function get_TemplateDataComponent() {
    _init_properties_component_kt__lifbkl();
    return templateDataComponent;
  }
  var templateDataComponent;
  function get_RelativeConnectorsComponent() {
    _init_properties_component_kt__lifbkl();
    return relativeConnectorsComponent;
  }
  var relativeConnectorsComponent;
  function get_AssemblyPartsComponent() {
    _init_properties_component_kt__lifbkl();
    return assemblyPartsComponent;
  }
  var assemblyPartsComponent;
  function get_ViewerComponent() {
    _init_properties_component_kt__lifbkl();
    return viewerComponent;
  }
  var viewerComponent;
  function get_ProductComponent() {
    _init_properties_component_kt__lifbkl();
    return productComponent;
  }
  var productComponent;
  function SelectedComponent() {
    _init_properties_component_kt__lifbkl();
    return SelectedComponent_instance;
  }
  function SceneReloading() {
    _init_properties_component_kt__lifbkl();
    return SceneReloadingComponent_instance;
  }
  function RenderedComponent() {
    _init_properties_component_kt__lifbkl();
    return RenderedComponent_instance;
  }
  function InSceneComponent() {
    _init_properties_component_kt__lifbkl();
    return InSceneComponent_instance;
  }
  function StaticComponent() {
    _init_properties_component_kt__lifbkl();
    return StaticComponent_getInstance();
  }
  function SelectableComponent$_init_$ref_pdu60u() {
    var l = function () {
      return new SelectableComponent();
    };
    l.callableName = '<init>';
    return l;
  }
  function DraggableComponent$_init_$ref_8nu9aj() {
    var l = function () {
      return new DraggableComponent();
    };
    l.callableName = '<init>';
    return l;
  }
  function SnapRootComponent$_init_$ref_u9ilxo() {
    var l = function () {
      return new SnapRootComponent();
    };
    l.callableName = '<init>';
    return l;
  }
  function historyChangedEventComponent$lambda(eventTypeName) {
    _init_properties_component_kt__lifbkl();
    return new HistoryChangedEventComponent(valueOf_0(eventTypeName));
  }
  function WorldSpaceDragEventComponent$_init_$ref_2xqn0m() {
    var l = function (p0, p1) {
      return new WorldSpaceDragEventComponent(p0, p1);
    };
    l.callableName = '<init>';
    return l;
  }
  function ClickEventComponent$_init_$ref_kxikre() {
    var l = function (p0) {
      return new ClickEventComponent(p0);
    };
    l.callableName = '<init>';
    return l;
  }
  function LocalTransformComponent$_init_$ref_xjesuv() {
    var l = function (p0) {
      return new LocalTransformComponent(p0);
    };
    l.callableName = '<init>';
    return l;
  }
  function ConnectorsComponent$_init_$ref_qm59bi() {
    var l = function (p0) {
      return new ConnectorsComponent(p0);
    };
    l.callableName = '<init>';
    return l;
  }
  function ChildComponent$_init_$ref_yhw7t0() {
    var l = function (p0) {
      return new ChildComponent(p0);
    };
    l.callableName = '<init>';
    return l;
  }
  function ParentComponent$_init_$ref_5hpzki() {
    var l = function (p0) {
      return new ParentComponent(p0);
    };
    l.callableName = '<init>';
    return l;
  }
  function ViewerObjectComponent$_init_$ref_ijsie1() {
    var l = function (p0) {
      return new ViewerObjectComponent(p0);
    };
    l.callableName = '<init>';
    return l;
  }
  function ConnectionRootComponent$_init_$ref_91dp4o() {
    var l = function () {
      return new ConnectionRootComponent();
    };
    l.callableName = '<init>';
    return l;
  }
  function ProductPartComponent$_init_$ref_ysmpee() {
    var l = function (p0) {
      return new ProductPartComponent(p0);
    };
    l.callableName = '<init>';
    return l;
  }
  function WorldTransformComponent$_init_$ref_t6duq() {
    var l = function (p0) {
      return new WorldTransformComponent(p0);
    };
    l.callableName = '<init>';
    return l;
  }
  function TemplateDataComponent$_init_$ref_f0kftg() {
    var l = function (p0, p1, p2, p3, p4) {
      return new TemplateDataComponent(p0, p1, p2, p3, p4);
    };
    l.callableName = '<init>';
    return l;
  }
  function RelativeConnectorsComponent$_init_$ref_ovg1ba() {
    var l = function (p0) {
      return new RelativeConnectorsComponent(p0);
    };
    l.callableName = '<init>';
    return l;
  }
  function AssemblyPartsComponent$_init_$ref_y1v56q() {
    var l = function (p0) {
      return AssemblyPartsComponent_init_$Create$(p0);
    };
    l.callableName = '<init>';
    return l;
  }
  function ViewerComponent$_init_$ref_b4gcw6() {
    var l = function (p0) {
      return new ViewerComponent(p0);
    };
    l.callableName = '<init>';
    return l;
  }
  function ProductComponent$_init_$ref_wrnq5l() {
    var l = function (p0) {
      return new ProductComponent(p0);
    };
    l.callableName = '<init>';
    return l;
  }
  var properties_initialized_component_kt_mmiqdv;
  function _init_properties_component_kt__lifbkl() {
    if (!properties_initialized_component_kt_mmiqdv) {
      properties_initialized_component_kt_mmiqdv = true;
      selectable = SelectableComponent$_init_$ref_pdu60u();
      draggable = DraggableComponent$_init_$ref_8nu9aj();
      snapRootComponent = SnapRootComponent$_init_$ref_u9ilxo();
      HistoryEvent = HistoryEvent_instance;
      historyChangedEventComponent = historyChangedEventComponent$lambda;
      worldSpaceDragEventComponent = WorldSpaceDragEventComponent$_init_$ref_2xqn0m();
      clickEventComponent = ClickEventComponent$_init_$ref_kxikre();
      localTransformation = LocalTransformComponent$_init_$ref_xjesuv();
      connectorsComponent = ConnectorsComponent$_init_$ref_qm59bi();
      childComponent = ChildComponent$_init_$ref_yhw7t0();
      parentComponent = ParentComponent$_init_$ref_5hpzki();
      viewerObjectComponent = ViewerObjectComponent$_init_$ref_ijsie1();
      connectionRootComponent = ConnectionRootComponent$_init_$ref_91dp4o();
      productPartComponent = ProductPartComponent$_init_$ref_ysmpee();
      worldTransformComponent = WorldTransformComponent$_init_$ref_t6duq();
      componentIds = ComponentIds_instance;
      componentIdSpan = ComponentIdSpan_instance;
      templateDataComponent = TemplateDataComponent$_init_$ref_f0kftg();
      relativeConnectorsComponent = RelativeConnectorsComponent$_init_$ref_ovg1ba();
      assemblyPartsComponent = AssemblyPartsComponent$_init_$ref_y1v56q();
      viewerComponent = ViewerComponent$_init_$ref_b4gcw6();
      productComponent = ProductComponent$_init_$ref_wrnq5l();
    }
  }
  function _CoreDebug(core) {
    this.core = core;
    this.coreVisualization = null;
    this.dragSurfaceNormalVisualizationSystem = new DragSurfaceNormalVisualizationSystem(this.core.services);
    this.drawDragGhostSystem = new DrawDragGhostSystem(this.core.services);
    this.validationsMeasurer = new Measurer();
    this.measuringEntityManagerWatcher = new MeasuringEntityManagerWatcher(this.core.services.entityManager);
    this.placementService = new PlacementService(this.core.services);
    this.core.services.entityManager.registerSystem(this.dragSurfaceNormalVisualizationSystem);
    this.dragSurfaceNormalVisualizationSystem.disable();
    this.core.services.entityManager.registerSystem(this.drawDragGhostSystem);
    this.drawDragGhostSystem.disable();
    this.coreVersion = this.core.version();
    var tmp = this;
    // Inline function 'kotlin.collections.mutableMapOf' call
    tmp.n4g_1 = LinkedHashMap_init_$Create$();
  }
  protoOf(_CoreDebug).o4g = function () {
    return this.core;
  };
  protoOf(_CoreDebug).p4g = function (_set____db54di) {
    this.coreVisualization = _set____db54di;
  };
  protoOf(_CoreDebug).q4g = function () {
    return this.coreVisualization;
  };
  protoOf(_CoreDebug).w3q = function () {
    return this.dragSurfaceNormalVisualizationSystem;
  };
  protoOf(_CoreDebug).r4g = function () {
    return this.drawDragGhostSystem;
  };
  protoOf(_CoreDebug).s4g = function () {
    return this.validationsMeasurer;
  };
  protoOf(_CoreDebug).t4g = function () {
    return this.measuringEntityManagerWatcher;
  };
  protoOf(_CoreDebug).u4g = function () {
    return this.placementService;
  };
  protoOf(_CoreDebug).getAllOfCore = function () {
    return _;
  };
  protoOf(_CoreDebug).toggleColliders = function () {
    this.enableVisualization(this.core.services);
    var tmp0_safe_receiver = this.coreVisualization;
    if (tmp0_safe_receiver == null)
      null;
    else {
      tmp0_safe_receiver.toggleColliders();
    }
  };
  protoOf(_CoreDebug).v4g = function () {
    return this.coreVersion;
  };
  protoOf(_CoreDebug).toggleConnectors = function () {
    this.enableVisualization(this.core.services);
    var tmp0_safe_receiver = this.coreVisualization;
    if (tmp0_safe_receiver == null)
      null;
    else {
      tmp0_safe_receiver.toggleConnectors();
    }
  };
  protoOf(_CoreDebug).toggleFunctionalMargin = function () {
    this.enableVisualization(this.core.services);
    var tmp0_safe_receiver = this.coreVisualization;
    if (tmp0_safe_receiver == null)
      null;
    else {
      tmp0_safe_receiver.toggleFunctionalMargin();
    }
  };
  protoOf(_CoreDebug).toggleFunctionalZones = function () {
    this.enableVisualization(this.core.services);
    var tmp0_safe_receiver = this.coreVisualization;
    if (tmp0_safe_receiver == null)
      null;
    else {
      tmp0_safe_receiver.toggleFunctionalZone();
    }
  };
  protoOf(_CoreDebug).toggleAutoAdaptHostZone = function () {
    this.enableVisualization(this.core.services);
    var tmp0_safe_receiver = this.coreVisualization;
    if (tmp0_safe_receiver == null)
      null;
    else {
      tmp0_safe_receiver.toggleAutoAdaptHostZone();
    }
  };
  protoOf(_CoreDebug).toggleDragSurfaceVisualization = function () {
    this.enableVisualization(this.core.services);
    var tmp0_safe_receiver = this.coreVisualization;
    if (tmp0_safe_receiver == null)
      null;
    else {
      tmp0_safe_receiver.toggleDragSurfaces();
    }
  };
  protoOf(_CoreDebug).toggleDragPointVisualization = function () {
    this.enableVisualization(this.core.services);
    var tmp0_safe_receiver = this.coreVisualization;
    if (tmp0_safe_receiver == null)
      null;
    else {
      tmp0_safe_receiver.toggleDragProjectionPoint();
    }
  };
  protoOf(_CoreDebug).enableVisualization = function (coreServices) {
    if (this.coreVisualization == null) {
      var visualizer = new DefaultVisualizer(coreServices, new ModelInfoComponent('', 'https://content.dexf.ikea.com/cdn/asset/kvadrat/rt/gojxjez4vka8.glb', ''));
      this.coreVisualization = new CoreVisualization(coreServices, visualizer, visualizer);
    }
  };
  protoOf(_CoreDebug).getEntityById = function (id) {
    // Inline function 'kotlin.collections.find' call
    var this_0 = this.core.services.entityManager.entities;
    var tmp$ret$1;
    $l$block: {
      // Inline function 'kotlin.collections.firstOrNull' call
      var inductionVariable = 0;
      var last = this_0.length;
      while (inductionVariable < last) {
        var element = this_0[inductionVariable];
        inductionVariable = inductionVariable + 1 | 0;
        // Inline function 'com.ikea.core.debug.CoreDebug.getEntityById.<anonymous>' call
        if (element.id === id) {
          tmp$ret$1 = element;
          break $l$block;
        }
      }
      tmp$ret$1 = null;
    }
    var entity = tmp$ret$1;
    if (entity == null) {
      echoStandardConsole('No entity with given id found');
    }
    return entity;
  };
  protoOf(_CoreDebug).getEntitiesWithComponents = function (componentIds) {
    // Inline function 'kotlin.collections.filter' call
    // Inline function 'kotlin.collections.filterTo' call
    var this_0 = this.core.services.entityManager.entities;
    var destination = ArrayList_init_$Create$();
    var inductionVariable = 0;
    var last = this_0.length;
    while (inductionVariable < last) {
      var element = this_0[inductionVariable];
      inductionVariable = inductionVariable + 1 | 0;
      // Inline function 'com.ikea.core.debug.CoreDebug.getEntitiesWithComponents.<anonymous>' call
      var tmp$ret$1;
      $l$block: {
        // Inline function 'kotlin.collections.all' call
        var inductionVariable_0 = 0;
        var last_0 = componentIds.length;
        while (inductionVariable_0 < last_0) {
          var element_0 = componentIds[inductionVariable_0];
          inductionVariable_0 = inductionVariable_0 + 1 | 0;
          // Inline function 'com.ikea.core.debug.CoreDebug.getEntitiesWithComponents.<anonymous>.<anonymous>' call
          if (!element.hasComponent(element_0)) {
            tmp$ret$1 = false;
            break $l$block;
          }
        }
        tmp$ret$1 = true;
      }
      if (tmp$ret$1) {
        destination.q(element);
      }
    }
    var entities = destination;
    if (entities.b1()) {
      echoStandardConsole('No entities with given components found');
    }
    // Inline function 'kotlin.collections.toTypedArray' call
    return copyToArray(entities);
  };
  protoOf(_CoreDebug).getSelectedEntity = function () {
    return findSelectedEntity(this.core);
  };
  protoOf(_CoreDebug).validateSelectedEntity = function () {
    var tmp0_safe_receiver = findSelectedEntity(this.core);
    if (tmp0_safe_receiver == null)
      null;
    else {
      // Inline function 'kotlin.let' call
      // Inline function 'kotlin.contracts.contract' call
      var result = this.core.services.validations.validateCurrentState(tmp0_safe_receiver, false);
      // Inline function 'kotlin.collections.toTypedArray' call
      // Inline function 'kotlin.collections.filter' call
      // Inline function 'kotlin.collections.filterTo' call
      var destination = ArrayList_init_$Create$();
      var inductionVariable = 0;
      var last = result.length;
      while (inductionVariable < last) {
        var element = result[inductionVariable];
        inductionVariable = inductionVariable + 1 | 0;
        // Inline function 'com.ikea.core.debug.CoreDebug.validateSelectedEntity.<anonymous>.<anonymous>' call
        if (element.resultType.equals(ValidationResultType_FAIL_getInstance())) {
          destination.q(element);
        }
      }
      var failed = copyToArray(destination);
      // Inline function 'kotlin.collections.toTypedArray' call
      // Inline function 'kotlin.collections.filter' call
      // Inline function 'kotlin.collections.filterTo' call
      var destination_0 = ArrayList_init_$Create$();
      var inductionVariable_0 = 0;
      var last_0 = result.length;
      while (inductionVariable_0 < last_0) {
        var element_0 = result[inductionVariable_0];
        inductionVariable_0 = inductionVariable_0 + 1 | 0;
        // Inline function 'com.ikea.core.debug.CoreDebug.validateSelectedEntity.<anonymous>.<anonymous>' call
        if (element_0.resultType.equals(ValidationResultType_WARNING_getInstance())) {
          destination_0.q(element_0);
        }
      }
      var warning = copyToArray(destination_0);
      // Inline function 'kotlin.collections.isNotEmpty' call
      // Inline function 'kotlin.collections.isEmpty' call
      if (!(failed.length === 0)) {
        echoStandardConsole('' + get_displayName(tmp0_safe_receiver) + ' validation failed:');
      } else {
        // Inline function 'kotlin.collections.isNotEmpty' call
        // Inline function 'kotlin.collections.isEmpty' call
        if (!(warning.length === 0)) {
          echoStandardConsole('' + get_displayName(tmp0_safe_receiver) + ' validated successfully with warnings');
        } else {
          echoStandardConsole('' + get_displayName(tmp0_safe_receiver) + ' validated successfully');
        }
      }
      return new SortedValidationResult(warning, failed);
    }
    return null;
  };
  protoOf(_CoreDebug).printRegisteredSystems = function () {
    // Inline function 'kotlin.collections.forEachIndexed' call
    var index = 0;
    var indexedObject = this.core.services.entityManager.getSystemsRegistered();
    var inductionVariable = 0;
    var last = indexedObject.length;
    while (inductionVariable < last) {
      var item = indexedObject[inductionVariable];
      inductionVariable = inductionVariable + 1 | 0;
      // Inline function 'com.ikea.core.debug.CoreDebug.printRegisteredSystems.<anonymous>' call
      var tmp1 = index;
      index = tmp1 + 1 | 0;
      echoStandardConsole('' + tmp1 + '. ' + item.id + ' enabled: ' + item.isEnabled);
    }
  };
  protoOf(_CoreDebug).printSystemsListeningToComponent = function (componentId) {
    // Inline function 'kotlin.collections.forEachIndexed' call
    var index = 0;
    var indexedObject = this.core.services.entityManager.getSystemsRegisteredForComponent(componentId);
    var inductionVariable = 0;
    var last = indexedObject.length;
    while (inductionVariable < last) {
      var item = indexedObject[inductionVariable];
      inductionVariable = inductionVariable + 1 | 0;
      // Inline function 'com.ikea.core.debug.CoreDebug.printSystemsListeningToComponent.<anonymous>' call
      var tmp1 = index;
      index = tmp1 + 1 | 0;
      echoStandardConsole('' + tmp1 + '. ' + item.id + ' enabled: ' + item.isEnabled);
    }
  };
  protoOf(_CoreDebug).enableSystem = function (i) {
    var tmp0_safe_receiver = getSystem(i, this.core);
    if (tmp0_safe_receiver == null)
      null;
    else {
      tmp0_safe_receiver.enable();
    }
  };
  protoOf(_CoreDebug).disableSystem = function (i) {
    var tmp0_safe_receiver = getSystem(i, this.core);
    if (tmp0_safe_receiver == null)
      null;
    else {
      tmp0_safe_receiver.disable();
    }
  };
  protoOf(_CoreDebug).printValidationRules = function () {
    // Inline function 'kotlin.collections.forEachIndexed' call
    var index = 0;
    var indexedObject = this.core.getValidations();
    var inductionVariable = 0;
    var last = indexedObject.length;
    while (inductionVariable < last) {
      var item = indexedObject[inductionVariable];
      inductionVariable = inductionVariable + 1 | 0;
      // Inline function 'com.ikea.core.debug.CoreDebug.printValidationRules.<anonymous>' call
      var tmp1 = index;
      index = tmp1 + 1 | 0;
      echoStandardConsole('' + tmp1 + '. ' + item.id + ' enabled: ' + item.isEnabled);
    }
  };
  protoOf(_CoreDebug).enableValidationRule = function (i) {
    var tmp0_safe_receiver = getValidationRule(i, this.core);
    if (tmp0_safe_receiver == null)
      null;
    else {
      tmp0_safe_receiver.enable();
    }
  };
  protoOf(_CoreDebug).disableValidationRule = function (i) {
    var tmp0_safe_receiver = getValidationRule(i, this.core);
    if (tmp0_safe_receiver == null)
      null;
    else {
      tmp0_safe_receiver.disable();
    }
  };
  protoOf(_CoreDebug).startMeasuringValidationRules = function () {
    var tmp = this.core.services.validations;
    // Inline function 'kotlin.also' call
    var this_0 = this.validationsMeasurer;
    // Inline function 'kotlin.contracts.contract' call
    // Inline function 'com.ikea.core.debug.CoreDebug.startMeasuringValidationRules.<anonymous>' call
    this_0.clear();
    tmp.measurer = this_0;
  };
  protoOf(_CoreDebug).stopMeasuringValidationRulesAndPrintResults = function () {
    // Inline function 'kotlin.collections.forEach' call
    var indexedObject = this.stopMeasuringValidationRulesAndGetResults();
    var inductionVariable = 0;
    var last = indexedObject.length;
    while (inductionVariable < last) {
      var element = indexedObject[inductionVariable];
      inductionVariable = inductionVariable + 1 | 0;
      // Inline function 'com.ikea.core.debug.CoreDebug.stopMeasuringValidationRulesAndPrintResults.<anonymous>' call
      echoStandardConsole(element);
    }
  };
  protoOf(_CoreDebug).stopMeasuringValidationRulesAndGetResults = function () {
    this.core.services.validations.measurer = null;
    // Inline function 'kotlin.collections.toTypedArray' call
    var this_0 = this.validationsMeasurer.getMeasurementsFormatted();
    return copyToArray(this_0);
  };
  protoOf(_CoreDebug).startMeasuringSystems = function () {
    this.core.services.entityManager.addWatcher(this.measuringEntityManagerWatcher);
    this.measuringEntityManagerWatcher.measurer.clear();
  };
  protoOf(_CoreDebug).stopMeasuringSystemsAndPrintResults = function () {
    // Inline function 'kotlin.collections.forEach' call
    var indexedObject = this.stopMeasuringSystemsAndGetResults();
    var inductionVariable = 0;
    var last = indexedObject.length;
    while (inductionVariable < last) {
      var element = indexedObject[inductionVariable];
      inductionVariable = inductionVariable + 1 | 0;
      // Inline function 'com.ikea.core.debug.CoreDebug.stopMeasuringSystemsAndPrintResults.<anonymous>' call
      echoStandardConsole(element);
    }
  };
  protoOf(_CoreDebug).stopMeasuringSystemsAndGetResults = function () {
    this.core.services.entityManager.removeWatcher(this.measuringEntityManagerWatcher);
    // Inline function 'kotlin.collections.toTypedArray' call
    var this_0 = this.measuringEntityManagerWatcher.measurer.getMeasurementsFormatted();
    return copyToArray(this_0);
  };
  protoOf(_CoreDebug).traceComponentChainOnce = function (componentId) {
    new LoggingEntityManagerWatcher(this.core.services.entityManager, componentId);
  };
  protoOf(_CoreDebug).validateSnapsForSelectedEntity = function (hostId) {
    var tmp0_safe_receiver = findSelectedEntity(this.core);
    if (tmp0_safe_receiver == null)
      null;
    else {
      // Inline function 'kotlin.let' call
      // Inline function 'kotlin.contracts.contract' call
      this.n4g_1.z();
      // Inline function 'kotlin.collections.find' call
      var this_0 = this.core.services.sceneManager.entities;
      var tmp$ret$1;
      $l$block: {
        // Inline function 'kotlin.collections.firstOrNull' call
        var inductionVariable = 0;
        var last = this_0.length;
        while (inductionVariable < last) {
          var element = this_0[inductionVariable];
          inductionVariable = inductionVariable + 1 | 0;
          // Inline function 'com.ikea.core.debug.CoreDebug.validateSnapsForSelectedEntity.<anonymous>.<anonymous>' call
          if (element.id === hostId) {
            tmp$ret$1 = element;
            break $l$block;
          }
        }
        tmp$ret$1 = null;
      }
      var tmp0_safe_receiver_0 = tmp$ret$1;
      if (tmp0_safe_receiver_0 == null)
        null;
      else {
        // Inline function 'kotlin.let' call
        // Inline function 'kotlin.contracts.contract' call
        var indexedObject = SnapUtils_instance.matchingSnapActionCandidates(tmp0_safe_receiver, tmp0_safe_receiver_0, new SnapSettings(true));
        var inductionVariable_0 = 0;
        var last_0 = indexedObject.length;
        while (inductionVariable_0 < last_0) {
          var element_0 = indexedObject[inductionVariable_0];
          inductionVariable_0 = inductionVariable_0 + 1 | 0;
          // Inline function 'com.ikea.core.debug.CoreDebug.validateSnapsForSelectedEntity.<anonymous>.<anonymous>.<anonymous>' call
          var snapResult = new Pair(element_0, this.core.services.validations.validateSnap(element_0, false));
          $l$block_0: {
            // Inline function 'com.ikea.core.utils.orElse' call
            var tmp0_safe_receiver_1 = this.n4g_1.b3(element_0.host);
            if ((tmp0_safe_receiver_1 == null ? null : tmp0_safe_receiver_1.q(snapResult)) == null) {
              var this_1 = this.n4g_1;
              var key = element_0.host;
              var value = mutableListOf([snapResult]);
              this_1.r2(key, value);
              break $l$block_0;
            }
          }
        }
      }
      var index = 0;
      // Inline function 'kotlin.collections.forEach' call
      // Inline function 'kotlin.collections.iterator' call
      var tmp0_iterator = this.n4g_1.q2().t();
      while (tmp0_iterator.u()) {
        var element_1 = tmp0_iterator.w();
        // Inline function 'com.ikea.core.debug.CoreDebug.validateSnapsForSelectedEntity.<anonymous>.<anonymous>' call
        // Inline function 'kotlin.collections.component1' call
        var host = element_1.t2();
        // Inline function 'kotlin.collections.component2' call
        var snapResults = element_1.u2();
        echoStandardConsole('Host ' + get_displayName(host) + ' id: ' + host.id);
        // Inline function 'kotlin.collections.forEach' call
        var tmp0_iterator_0 = snapResults.t();
        while (tmp0_iterator_0.u()) {
          var element_2 = tmp0_iterator_0.w();
          // Inline function 'com.ikea.core.debug.CoreDebug.validateSnapsForSelectedEntity.<anonymous>.<anonymous>.<anonymous>' call
          var snap = element_2.af();
          var result = element_2.bf();
          var tmp0 = index;
          index = tmp0 + 1 | 0;
          var tmp = snap.hostConnector.key;
          var tmp_0 = snap.guestConnector.key;
          var tmp_1 = snap.priority;
          var tmp_2 = snap.inActivationDistance();
          var tmp_3;
          // Inline function 'kotlin.collections.isEmpty' call
          if (result.length === 0) {
            tmp_3 = 'SUCCESS';
          } else {
            tmp_3 = 'FAIL due to:';
          }
          echoStandardConsole('' + tmp0 + '. ' + tmp + ' <--> ' + tmp_0 + ' p=' + tmp_1 + ' iad=' + tmp_2 + ' ' + tmp_3);
          var tmp1_safe_receiver = snap.alignmentInitiatorCandidate;
          if (tmp1_safe_receiver == null)
            null;
          else {
            // Inline function 'kotlin.let' call
            // Inline function 'kotlin.contracts.contract' call
            echoStandardConsole('   (due to alignment ' + tmp1_safe_receiver.hostConnector.key + ' <--> ' + tmp1_safe_receiver.guestConnector.key + ' p=' + tmp1_safe_receiver.priority + ')');
          }
          // Inline function 'kotlin.collections.forEach' call
          var inductionVariable_1 = 0;
          var last_1 = result.length;
          while (inductionVariable_1 < last_1) {
            var element_3 = result[inductionVariable_1];
            inductionVariable_1 = inductionVariable_1 + 1 | 0;
            // Inline function 'com.ikea.core.debug.CoreDebug.validateSnapsForSelectedEntity.<anonymous>.<anonymous>.<anonymous>.<anonymous>' call
            echoStandardConsole(element_3);
          }
        }
        echoStandardConsole('---------------------------------');
      }
      echoStandardConsole('Perform a snap by calling:');
      echoStandardConsole('CoreDebug.performValidatedSnap(<index number>)');
    }
  };
  protoOf(_CoreDebug).performValidatedSnap = function (snapIndex) {
    var index = 0;
    // Inline function 'kotlin.collections.forEach' call
    // Inline function 'kotlin.collections.iterator' call
    var tmp0_iterator = this.n4g_1.q2().t();
    while (tmp0_iterator.u()) {
      var element = tmp0_iterator.w();
      // Inline function 'com.ikea.core.debug.CoreDebug.performValidatedSnap.<anonymous>' call
      // Inline function 'kotlin.collections.component2' call
      var snapResults = element.u2();
      // Inline function 'kotlin.collections.forEach' call
      var tmp0_iterator_0 = snapResults.t();
      while (tmp0_iterator_0.u()) {
        var element_0 = tmp0_iterator_0.w();
        // Inline function 'com.ikea.core.debug.CoreDebug.performValidatedSnap.<anonymous>.<anonymous>' call
        var snap = element_0.af();
        var tmp0 = index;
        index = tmp0 + 1 | 0;
        if (tmp0 === snapIndex) {
          snap.perform();
          return Unit_instance;
        }
      }
    }
    echoStandardConsole('No candidate with that index. (validateSnapsForSelectedEntity() must be run first)');
  };
  protoOf(_CoreDebug).help = function () {
    printHelp();
  };
  function findSelectedEntity(core) {
    // Inline function 'kotlin.collections.filter' call
    // Inline function 'kotlin.collections.filterTo' call
    var this_0 = core.services.sceneManager.entities;
    var destination = ArrayList_init_$Create$();
    var inductionVariable = 0;
    var last = this_0.length;
    while (inductionVariable < last) {
      var element = this_0[inductionVariable];
      inductionVariable = inductionVariable + 1 | 0;
      // Inline function 'com.ikea.core.debug.findSelectedEntity.<anonymous>' call
      if (element.hasComponent(0)) {
        destination.q(element);
      }
    }
    var selected = destination;
    if (selected.b1()) {
      echoStandardConsole('No entity selected');
    } else if (selected.n() > 1) {
      echoStandardConsole('Several entities selected, returning first');
    }
    return firstOrNull(selected);
  }
  function getSystem(i, core) {
    var systems = core.services.entityManager.getSystemsRegistered();
    if (i < 0 ? true : i > systems.length) {
      echoStandardConsole('Invalid system index');
      return null;
    }
    return systems[i];
  }
  function getValidationRule(i, core) {
    var validationRules = core.getValidations();
    if (i < 0 ? true : i > validationRules.length) {
      echoStandardConsole('Invalid validation rule index');
      return null;
    }
    return validationRules[i];
  }
  function SortedValidationResult(warning, fail) {
    this.w4g_1 = warning;
    this.x4g_1 = fail;
  }
  protoOf(SortedValidationResult).equals = function (other) {
    if (this === other)
      return true;
    if (other == null ? true : !getKClassFromExpression(this).equals(getKClassFromExpression(other)))
      return false;
    if (!(other instanceof SortedValidationResult))
      THROW_CCE();
    if (!contentEquals(this.w4g_1, other.w4g_1))
      return false;
    if (!contentEquals(this.x4g_1, other.x4g_1))
      return false;
    return true;
  };
  protoOf(SortedValidationResult).hashCode = function () {
    var result = contentHashCode(this.w4g_1);
    result = imul(31, result) + contentHashCode(this.x4g_1) | 0;
    return result;
  };
  protoOf(SortedValidationResult).toString = function () {
    return 'SortedValidationResult(warning=' + toString(this.w4g_1) + ', fail=' + toString(this.x4g_1) + ')';
  };
  function printHelp() {
    var helpMessage = '###############################\n\n    Welcome to CoreDebug\n\n###############################\n\n### CoreDebug Systems\n\nCall enable() or disable() on any of the\nfollowing system to enable/disable it\n\n* drawDragGhostSystem\n\n### CoreDebug Visualization\n\nTo toggle visualization on and off:\n* toggleColliders()\n* toggleConnectors()\n* toggleAutoAdaptHostZone()\n* toggleFunctionalMargin()\n* toggleFunctionalZone()\n\n### CoreDebug functions:\n\n# Get entity with a specific id\nCoreDebug.getEntityById(id: string)\n\n# Get entities that have specific components. Will include detached entities, call with\n# InSceneComponent id (5) in componentIds array to only get entities that are in scene.\nCoreDebug.getEntitiesWithComponents(componentIds: number[])\n\n# Get selected entity\nCoreDebug.getSelectedEntity()\n\n# Validate selected entity and return results\nCoreDebug.validateSelectedEntity()\n\n# Print registered systems to console (with index)\nCoreDebug.printRegisteredSystems()\n\n# Print systems listening to a component in the order they listen\nCoreDebug.printSystemsListeningToComponent(componentId: number)\n\n# Enable system using index from printRegisteredSystems()\nCoreDebug.enableSystem(index: number)\n\n# Disable system using index from printRegisteredSystems()\nCoreDebug.disableSystem(index: number)\n\n# Print validation rules to console\nCoreDebug.printValidationRules()\n\n# Start measuring number of calls and time spent in each validation rule\nCoreDebug.startMeasuringValidationRules()\n\n# Stop measuring validation rules and print the results to console\nCoreDebug.stopMeasuringValidationRulesAndPrintResults()\n\n# Start measuring number of calls and time spent in each system callback function (add/update/remove per componentId)\nCoreDebug.startMeasuringSystems()\n\n# Stop measuring systems and print the results to console\nCoreDebug.stopMeasuringSystemsAndPrintResults()\n\n# Print a trace for how a component change propagates through systems\n# It will print the next propagation chain that involves the provided component\nCoreDebug.traceComponentChainOnce(componentId: number)\n\n# Find and validate all possible snaps for the selected entity. Optionally pass an entity id\n# to only get snaps with with that host. Prints out info about the snap and the validation\n# results per host entity ordered with an index. This index can be passed to performValidatedSnap()\n# Snap info: connector keys (host <--> guest), priority (p), if it is in activation\n# distance (iad) and if it originated from matching alignment connectors\nCoreDebug.validateSnapsForSelectedEntity(hostId?: string)\n\n# Performs the snap with a given index that you get from running validateSnapsForSelectedEntity()\n# The snap is performed regardless of the validation result\nCoreDebug.performValidatedSnap(snapIndex: number)\n\n# Print this help again\nCoreDebug.help()\n\n###############################';
    echoStandardConsole(helpMessage);
  }
  function get_ColliderUtils() {
    _init_properties_ColliderUtils_kt__buwx7v();
    return ColliderUtils;
  }
  var ColliderUtils;
  function get_CollisionUtils() {
    _init_properties_ColliderUtils_kt__buwx7v();
    return CollisionUtilsObj;
  }
  var CollisionUtilsObj;
  var properties_initialized_ColliderUtils_kt_kh6v71;
  function _init_properties_ColliderUtils_kt__buwx7v() {
    if (!properties_initialized_ColliderUtils_kt_kh6v71) {
      properties_initialized_ColliderUtils_kt_kh6v71 = true;
      ColliderUtils = ColliderUtils_instance;
      CollisionUtilsObj = CollisionUtils_instance;
    }
  }
  function get_ComponentUtils() {
    _init_properties_ComponentUtils_kt__d1ghsk();
    return ComponentUtils;
  }
  var ComponentUtils;
  var properties_initialized_ComponentUtils_kt_pakiie;
  function _init_properties_ComponentUtils_kt__d1ghsk() {
    if (!properties_initialized_ComponentUtils_kt_pakiie) {
      properties_initialized_ComponentUtils_kt_pakiie = true;
      ComponentUtils = ComponentUtils_instance;
    }
  }
  function get_ConnectionUtils() {
    _init_properties_ConnectionUtils_kt__o7o2tb();
    return ConnectionUtils;
  }
  var ConnectionUtils;
  var properties_initialized_ConnectionUtils_kt_jl8lf;
  function _init_properties_ConnectionUtils_kt__o7o2tb() {
    if (!properties_initialized_ConnectionUtils_kt_jl8lf) {
      properties_initialized_ConnectionUtils_kt_jl8lf = true;
      ConnectionUtils = ConnectionUtils_instance;
    }
  }
  function get_ConnectorUtils() {
    _init_properties_ConnectorUtils_kt__thp0w4();
    return ConnectorUtils;
  }
  var ConnectorUtils;
  var properties_initialized_ConnectorUtils_kt_7bcy3e;
  function _init_properties_ConnectorUtils_kt__thp0w4() {
    if (!properties_initialized_ConnectorUtils_kt_7bcy3e) {
      properties_initialized_ConnectorUtils_kt_7bcy3e = true;
      ConnectorUtils = ConnectorUtils_instance;
    }
  }
  function get_EntityGroupUtils() {
    _init_properties_EntityGroupUtils_kt__fa1pyj();
    return EntityGroupUtils;
  }
  var EntityGroupUtils;
  var properties_initialized_EntityGroupUtils_kt_6umwvd;
  function _init_properties_EntityGroupUtils_kt__fa1pyj() {
    if (!properties_initialized_EntityGroupUtils_kt_6umwvd) {
      properties_initialized_EntityGroupUtils_kt_6umwvd = true;
      EntityGroupUtils = EntityGroupUtils_instance;
    }
  }
  function get_HierarchyUtils() {
    _init_properties_HierarchyUtils_kt__r367z0();
    return HierarchyUtils;
  }
  var HierarchyUtils;
  var properties_initialized_HierarchyUtils_kt_1xdqbi;
  function _init_properties_HierarchyUtils_kt__r367z0() {
    if (!properties_initialized_HierarchyUtils_kt_1xdqbi) {
      properties_initialized_HierarchyUtils_kt_1xdqbi = true;
      HierarchyUtils = HierarchyUtils_instance;
    }
  }
  function get_MeasurementUtils() {
    _init_properties_MeasurementUtils_kt__2fjxth();
    return MeasurementUtils;
  }
  var MeasurementUtils;
  var properties_initialized_MeasurementUtils_kt_gl5jyh;
  function _init_properties_MeasurementUtils_kt__2fjxth() {
    if (!properties_initialized_MeasurementUtils_kt_gl5jyh) {
      properties_initialized_MeasurementUtils_kt_gl5jyh = true;
      MeasurementUtils = MeasurementUtils_getInstance();
    }
  }
  function get_ModelUtils() {
    _init_properties_ModelUtils_kt__elp6nc();
    return modelUtils;
  }
  var modelUtils;
  var properties_initialized_ModelUtils_kt_c4z2fe;
  function _init_properties_ModelUtils_kt__elp6nc() {
    if (!properties_initialized_ModelUtils_kt_c4z2fe) {
      properties_initialized_ModelUtils_kt_c4z2fe = true;
      modelUtils = ModelUtils_getInstance();
    }
  }
  function get_ProductUtils() {
    _init_properties_ProductUtils_kt__wn29wi();
    return ProductUtils;
  }
  var ProductUtils;
  var properties_initialized_ProductUtils_kt_fydiis;
  function _init_properties_ProductUtils_kt__wn29wi() {
    if (!properties_initialized_ProductUtils_kt_fydiis) {
      properties_initialized_ProductUtils_kt_fydiis = true;
      ProductUtils = ProductUtils_instance;
    }
  }
  function get_RaycastUtils() {
    _init_properties_RaycastUtils_kt__altj14();
    return RaycastUtils;
  }
  var RaycastUtils;
  var properties_initialized_RaycastUtils_kt_sh5hti;
  function _init_properties_RaycastUtils_kt__altj14() {
    if (!properties_initialized_RaycastUtils_kt_sh5hti) {
      properties_initialized_RaycastUtils_kt_sh5hti = true;
      RaycastUtils = RaycastUtils_instance;
    }
  }
  function get_SnapActionCandidateSortAndSelectStrategies() {
    _init_properties_SnapActionCandidateSortAndSelectStrategy_kt__do0a3f();
    return SnapActionCandidateSortAndSelectStrategies;
  }
  var SnapActionCandidateSortAndSelectStrategies;
  var properties_initialized_SnapActionCandidateSortAndSelectStrategy_kt_q48s6f;
  function _init_properties_SnapActionCandidateSortAndSelectStrategy_kt__do0a3f() {
    if (!properties_initialized_SnapActionCandidateSortAndSelectStrategy_kt_q48s6f) {
      properties_initialized_SnapActionCandidateSortAndSelectStrategy_kt_q48s6f = true;
      SnapActionCandidateSortAndSelectStrategies = SnapActionCandidateSortAndSelectStrategies_getInstance();
    }
  }
  function get_SnapUtils() {
    _init_properties_SnapUtils_kt__24ofor();
    return SnapUtils;
  }
  var SnapUtils;
  var properties_initialized_SnapUtils_kt_y15qfr;
  function _init_properties_SnapUtils_kt__24ofor() {
    if (!properties_initialized_SnapUtils_kt_y15qfr) {
      properties_initialized_SnapUtils_kt_y15qfr = true;
      SnapUtils = SnapUtils_instance;
    }
  }
  function get_TransformUtils() {
    _init_properties_TransformUtils_kt__4zsf3v();
    return TransformUtils;
  }
  var TransformUtils;
  var properties_initialized_TransformUtils_kt_j01ttz;
  function _init_properties_TransformUtils_kt__4zsf3v() {
    if (!properties_initialized_TransformUtils_kt_j01ttz) {
      properties_initialized_TransformUtils_kt_j01ttz = true;
      TransformUtils = TransformUtils_instance;
    }
  }
  function get_OutlinedComponent() {
    _init_properties_components_kt__qkbrje();
    return outlined;
  }
  var outlined;
  function get_OutlineBlockingComponent() {
    _init_properties_components_kt__qkbrje();
    return outlineBlockingComponent;
  }
  var outlineBlockingComponent;
  function get_AutoAdaptHostComponent() {
    _init_properties_components_kt__qkbrje();
    return autoAdaptHost;
  }
  var autoAdaptHost;
  function get_AutoAdaptGuestComponent() {
    _init_properties_components_kt__qkbrje();
    return autoAdaptGuest;
  }
  var autoAdaptGuest;
  function get_AutoAdaptVariantComponent() {
    _init_properties_components_kt__qkbrje();
    return autoAdaptComponent;
  }
  var autoAdaptComponent;
  function get_ForceAutoAdaptWhenParentIsDraggedComponent() {
    _init_properties_components_kt__qkbrje();
    return forceAutoAdaptWhenParentIsDraggedComponent;
  }
  var forceAutoAdaptWhenParentIsDraggedComponent;
  function get_AllowedDoorPairsComponent() {
    _init_properties_components_kt__qkbrje();
    return allowedDoorPairsComponent;
  }
  var allowedDoorPairsComponent;
  function get_AlignmentConnectionsComponent() {
    _init_properties_components_kt__qkbrje();
    return alignmentConnectionsComponent;
  }
  var alignmentConnectionsComponent;
  function get_LightComponent() {
    _init_properties_components_kt__qkbrje();
    return lightComponent;
  }
  var lightComponent;
  function get_RoomDimensionsComponent() {
    _init_properties_components_kt__qkbrje();
    return roomDimensionsComponent;
  }
  var roomDimensionsComponent;
  function get_RoomPartComponent() {
    _init_properties_components_kt__qkbrje();
    return roomPartComponent;
  }
  var roomPartComponent;
  function DoorComponent() {
    _init_properties_components_kt__qkbrje();
    return DoorComponent_getInstance();
  }
  function FreeMoveComponent() {
    _init_properties_components_kt__qkbrje();
    return FreeMoveComponent_instance;
  }
  function IsDraggedComponent() {
    _init_properties_components_kt__qkbrje();
    return IsDraggedComponent_instance;
  }
  function RoomComponent() {
    _init_properties_components_kt__qkbrje();
    return RoomComponent_instance;
  }
  function OutlinedComponent$_init_$ref_h368dy() {
    var l = function () {
      return new OutlinedComponent();
    };
    l.callableName = '<init>';
    return l;
  }
  function OutlineBlockingComponent$_init_$ref_we6k5d() {
    var l = function () {
      return new OutlineBlockingComponent();
    };
    l.callableName = '<init>';
    return l;
  }
  function AutoAdaptHostComponent$_init_$ref_wtzggt() {
    var l = function (p0) {
      return new AutoAdaptHostComponent(p0);
    };
    l.callableName = '<init>';
    return l;
  }
  function AutoAdaptGuestComponent$_init_$ref_4n8cfn() {
    var l = function (p0, p1) {
      return new AutoAdaptGuestComponent(p0, p1);
    };
    l.callableName = '<init>';
    return l;
  }
  function AutoAdaptVariantComponent$_init_$ref_dn270a() {
    var l = function (p0) {
      return new AutoAdaptVariantComponent(p0);
    };
    l.callableName = '<init>';
    return l;
  }
  function ForceAutoAdaptWhenParentIsDraggedComponent$_init_$ref_egmtwc() {
    var l = function () {
      return new ForceAutoAdaptWhenParentIsDraggedComponent();
    };
    l.callableName = '<init>';
    return l;
  }
  function AllowedDoorPairsComponent$_init_$ref_o2qka3() {
    var l = function (p0) {
      return AllowedDoorPairsComponentFromArrays(p0);
    };
    l.callableName = '<init>';
    return l;
  }
  function AlignmentConnectionsComponent$_init_$ref_6s6xm() {
    var l = function (p0) {
      return new AlignmentConnectionsComponent(p0);
    };
    l.callableName = '<init>';
    return l;
  }
  function LightComponent$_init_$ref_fuiv0e() {
    var l = function (p0) {
      return new LightComponent(p0);
    };
    l.callableName = '<init>';
    return l;
  }
  function RoomDimensionsComponent$_init_$ref_3sq2j4() {
    var l = function (p0) {
      return new RoomDimensionsComponent(p0);
    };
    l.callableName = '<init>';
    return l;
  }
  function RoomPartComponent$_init_$ref_2w0hre() {
    var l = function (p0) {
      return new RoomPartComponent(p0);
    };
    l.callableName = '<init>';
    return l;
  }
  var properties_initialized_components_kt_8vt12w;
  function _init_properties_components_kt__qkbrje() {
    if (!properties_initialized_components_kt_8vt12w) {
      properties_initialized_components_kt_8vt12w = true;
      outlined = OutlinedComponent$_init_$ref_h368dy();
      outlineBlockingComponent = OutlineBlockingComponent$_init_$ref_we6k5d();
      autoAdaptHost = AutoAdaptHostComponent$_init_$ref_wtzggt();
      autoAdaptGuest = AutoAdaptGuestComponent$_init_$ref_4n8cfn();
      autoAdaptComponent = AutoAdaptVariantComponent$_init_$ref_dn270a();
      forceAutoAdaptWhenParentIsDraggedComponent = ForceAutoAdaptWhenParentIsDraggedComponent$_init_$ref_egmtwc();
      allowedDoorPairsComponent = AllowedDoorPairsComponent$_init_$ref_o2qka3();
      alignmentConnectionsComponent = AlignmentConnectionsComponent$_init_$ref_6s6xm();
      lightComponent = LightComponent$_init_$ref_fuiv0e();
      roomDimensionsComponent = RoomDimensionsComponent$_init_$ref_3sq2j4();
      roomPartComponent = RoomPartComponent$_init_$ref_2w0hre();
    }
  }
  function get_CoreDebug() {
    _init_properties_core_js_kt__sbuna3();
    return CoreDebug;
  }
  var CoreDebug;
  function CoreDebug$_init_$ref_fht3jl() {
    var l = function (p0) {
      return new _CoreDebug(p0);
    };
    l.callableName = '<init>';
    return l;
  }
  var properties_initialized_core_js_kt_xu6gx3;
  function _init_properties_core_js_kt__sbuna3() {
    if (!properties_initialized_core_js_kt_xu6gx3) {
      properties_initialized_core_js_kt_xu6gx3 = true;
      CoreDebug = CoreDebug$_init_$ref_fht3jl();
    }
  }
  function get_DynamicProductCatalog() {
    _init_properties_dynamic_range_js_kt__omhuxl();
    return DynamicProductCatalog_0;
  }
  var DynamicProductCatalog_0;
  function get_DynamicProduct() {
    _init_properties_dynamic_range_js_kt__omhuxl();
    return DynamicProduct_0;
  }
  var DynamicProduct_0;
  function get_ProductTemplate() {
    _init_properties_dynamic_range_js_kt__omhuxl();
    return ProductTemplate_0;
  }
  var ProductTemplate_0;
  function get_CatalogTemplateData() {
    _init_properties_dynamic_range_js_kt__omhuxl();
    return CatalogTemplateData_0;
  }
  var CatalogTemplateData_0;
  function get_Part() {
    _init_properties_dynamic_range_js_kt__omhuxl();
    return Part_0;
  }
  var Part_0;
  function get_ModelRenderInfo() {
    _init_properties_dynamic_range_js_kt__omhuxl();
    return ModelRenderInfo_0;
  }
  var ModelRenderInfo_0;
  function get_DynamicRangeUtils() {
    _init_properties_dynamic_range_js_kt__omhuxl();
    return DynamicRangeUtilsRef;
  }
  var DynamicRangeUtilsRef;
  function get_RelativePosition() {
    _init_properties_dynamic_range_js_kt__omhuxl();
    return relativePosition;
  }
  var relativePosition;
  function get_RelativeTransform() {
    _init_properties_dynamic_range_js_kt__omhuxl();
    return relativeTransform;
  }
  var relativeTransform;
  function get_PositionTemplate() {
    _init_properties_dynamic_range_js_kt__omhuxl();
    return positionTemplate;
  }
  var positionTemplate;
  function get_OriginRelativeTo() {
    _init_properties_dynamic_range_js_kt__omhuxl();
    return originRelativeTo;
  }
  var originRelativeTo;
  function get_PositionType() {
    _init_properties_dynamic_range_js_kt__omhuxl();
    return positionType;
  }
  var positionType;
  function get_VisualLightSourceComponent() {
    _init_properties_dynamic_range_js_kt__omhuxl();
    return visualLightSourceComponent;
  }
  var visualLightSourceComponent;
  function get_TemplateEditorService() {
    _init_properties_dynamic_range_js_kt__omhuxl();
    return TemplateEditorService_0;
  }
  var TemplateEditorService_0;
  function get_BoundItemTemplate() {
    _init_properties_dynamic_range_js_kt__omhuxl();
    return BoundItemTemplate_0;
  }
  var BoundItemTemplate_0;
  function get_Dimension() {
    _init_properties_dynamic_range_js_kt__omhuxl();
    return Dimension_0;
  }
  var Dimension_0;
  function get_Compartment() {
    _init_properties_dynamic_range_js_kt__omhuxl();
    return Compartment_0;
  }
  var Compartment_0;
  function get_CatalogGenerator() {
    _init_properties_dynamic_range_js_kt__omhuxl();
    return catalogGenerator;
  }
  var catalogGenerator;
  function PositionValue_0(value, type) {
    _init_properties_dynamic_range_js_kt__omhuxl();
    var tmp = Companion_getInstance_1();
    return new PositionValue(value, tmp.getByValue(type == null ? 0 : type));
  }
  function OriginTemplate_0(relation, relativeTo) {
    _init_properties_dynamic_range_js_kt__omhuxl();
    return new OriginTemplate(relation, OriginRelativeToImpostor_getInstance().toEnum(relativeTo));
  }
  function getMeta(dto) {
    _init_properties_dynamic_range_js_kt__omhuxl();
    var result = new getMeta$result$1();
    var tmp0_safe_receiver = dto.meta;
    if (tmp0_safe_receiver == null)
      null;
    else {
      // Inline function 'kotlin.collections.forEach' call
      // Inline function 'kotlin.collections.iterator' call
      var tmp0_iterator = tmp0_safe_receiver.q2().t();
      while (tmp0_iterator.u()) {
        var element = tmp0_iterator.w();
        // Inline function 'getMeta.<anonymous>' call
        // Inline function 'kotlin.collections.component1' call
        var key = element.t2();
        // Inline function 'kotlin.collections.component2' call
        var value = element.u2();
        var json = toString(value);
        if (!(json === ''))
          result[key] = JSON.parse(json);
      }
    }
    return result;
  }
  function DynamicProductCatalog$_init_$ref_ja14jo() {
    var l = function (p0, p1, p2) {
      return new DynamicProductCatalog(p0, p1, p2);
    };
    l.callableName = '<init>';
    return l;
  }
  function DynamicProduct$_init_$ref_m4augl() {
    var l = function (p0, p1, p2, p3, p4, p5, p6, p7, p8, p9, p10) {
      return new DynamicProduct(p0, p1, p2, p3, p4, p5, p6, p7, p8, p9, p10);
    };
    l.callableName = '<init>';
    return l;
  }
  function ProductTemplate$_init_$ref_e7fptw() {
    var l = function (p0, p1, p2, p3) {
      return new ProductTemplate(p0, p1, p2, p3);
    };
    l.callableName = '<init>';
    return l;
  }
  function CatalogTemplateData$_init_$ref_pugk1k() {
    var l = function (p0, p1, p2, p3, p4, p5, p6, p7, p8, p9) {
      return new CatalogTemplateData(p0, p1, p2, p3, p4, p5, p6, p7, p8, p9);
    };
    l.callableName = '<init>';
    return l;
  }
  function Part$_init_$ref_yjn15e() {
    var l = function (p0, p1, p2, p3) {
      return new Part(p0, p1, p2, p3);
    };
    l.callableName = '<init>';
    return l;
  }
  function ModelRenderInfo$_init_$ref_p9q3h4() {
    var l = function (p0, p1, p2) {
      return new ModelRenderInfo(p0, p1, p2);
    };
    l.callableName = '<init>';
    return l;
  }
  function RelativePosition$_init_$ref_etlu4w() {
    var l = function (p0, p1, p2) {
      return new RelativePosition(p0, p1, p2);
    };
    l.callableName = '<init>';
    return l;
  }
  function RelativeTransform$_init_$ref_qjbp7f() {
    var l = function (p0, p1) {
      return new RelativeTransform(p0, p1);
    };
    l.callableName = '<init>';
    return l;
  }
  function PositionTemplate$_init_$ref_2pz4ci() {
    var l = function (p0, p1) {
      return new PositionTemplate(p0, p1);
    };
    l.callableName = '<init>';
    return l;
  }
  function VisualLightSourceComponent$_init_$ref_bp7zb() {
    var l = function (p0, p1, p2) {
      return new VisualLightSourceComponent(p0, p1, p2);
    };
    l.callableName = '<init>';
    return l;
  }
  function TemplateEditorService$_init_$ref_97ywjt() {
    var l = function (p0, p1) {
      return new TemplateEditorService(p0, p1);
    };
    l.callableName = '<init>';
    return l;
  }
  function BoundItemTemplate$_init_$ref_xq74au() {
    var l = function (p0, p1, p2, p3, p4, p5, p6, p7) {
      return new BoundItemTemplate(p0, p1, p2, p3, p4, p5, p6, p7);
    };
    l.callableName = '<init>';
    return l;
  }
  function Dimension$_init_$ref_cvmjy7() {
    var l = function (p0, p1, p2, p3, p4, p5, p6, p7, p8) {
      return new Dimension(p0, p1, p2, p3, p4, p5, p6, p7, p8);
    };
    l.callableName = '<init>';
    return l;
  }
  function Compartment$_init_$ref_p4mln7() {
    var l = function (p0, p1) {
      return new Compartment(p0, p1);
    };
    l.callableName = '<init>';
    return l;
  }
  function CatalogGenerator$_init_$ref_itw2uj() {
    var l = function () {
      return new CatalogGenerator();
    };
    l.callableName = '<init>';
    return l;
  }
  function getMeta$result$1() {
  }
  var properties_initialized_dynamic_range_js_kt_i07y6v;
  function _init_properties_dynamic_range_js_kt__omhuxl() {
    if (!properties_initialized_dynamic_range_js_kt_i07y6v) {
      properties_initialized_dynamic_range_js_kt_i07y6v = true;
      DynamicProductCatalog_0 = DynamicProductCatalog$_init_$ref_ja14jo();
      DynamicProduct_0 = DynamicProduct$_init_$ref_m4augl();
      ProductTemplate_0 = ProductTemplate$_init_$ref_e7fptw();
      CatalogTemplateData_0 = CatalogTemplateData$_init_$ref_pugk1k();
      Part_0 = Part$_init_$ref_yjn15e();
      ModelRenderInfo_0 = ModelRenderInfo$_init_$ref_p9q3h4();
      DynamicRangeUtilsRef = Companion_getInstance_2();
      relativePosition = RelativePosition$_init_$ref_etlu4w();
      relativeTransform = RelativeTransform$_init_$ref_qjbp7f();
      positionTemplate = PositionTemplate$_init_$ref_2pz4ci();
      originRelativeTo = OriginRelativeToImpostor_getInstance();
      positionType = PositionTypeImpostor_instance;
      visualLightSourceComponent = VisualLightSourceComponent$_init_$ref_bp7zb();
      TemplateEditorService_0 = TemplateEditorService$_init_$ref_97ywjt();
      BoundItemTemplate_0 = BoundItemTemplate$_init_$ref_xq74au();
      Dimension_0 = Dimension$_init_$ref_cvmjy7();
      Compartment_0 = Compartment$_init_$ref_p4mln7();
      catalogGenerator = CatalogGenerator$_init_$ref_itw2uj();
    }
  }
  function ExperimentalPlacementService$_init_$ref_61iroz() {
    var l = function (p0, p1) {
      return new ExperimentalPlacementService(p0, p1);
    };
    l.callableName = '<init>';
    return l;
  }
  function LegacyPlacementHelper$_init_$ref_nbi9hh() {
    var l = function (p0, p1) {
      return new LegacyPlacementHelper(p0, p1);
    };
    l.callableName = '<init>';
    return l;
  }
  function ValidatedSnap$_init_$ref_b5n0rx() {
    var l = function (p0, p1) {
      return new ValidatedSnap(p0, p1);
    };
    l.callableName = '<init>';
    return l;
  }
  function Experimental() {
    experimental_js_instance_f39xui = this;
    var tmp = this;
    tmp.ExperimentalPlacementService = ExperimentalPlacementService$_init_$ref_61iroz();
    var tmp_0 = this;
    tmp_0.LegacyPlacementHelper = LegacyPlacementHelper$_init_$ref_nbi9hh();
    var tmp_1 = this;
    tmp_1.ValidatedSnap = ValidatedSnap$_init_$ref_b5n0rx();
  }
  protoOf(Experimental).y4g = function () {
    return this.ExperimentalPlacementService;
  };
  protoOf(Experimental).z4g = function () {
    return this.LegacyPlacementHelper;
  };
  protoOf(Experimental).a4h = function () {
    return this.ValidatedSnap;
  };
  var experimental_js_instance_f39xui;
  function experimental_js_getInstance_e6vaee() {
    if (experimental_js_instance_f39xui == null)
      new Experimental();
    return experimental_js_instance_f39xui;
  }
  function get_IPEXRangeFormatCatalog() {
    _init_properties_ipex_range_format_js_kt__6qn084();
    return ipexRangeFormatCatalog;
  }
  var ipexRangeFormatCatalog;
  function get_AmendableCatalog() {
    _init_properties_ipex_range_format_js_kt__6qn084();
    return amendableCatalog;
  }
  var amendableCatalog;
  function get_RangeItemDTO() {
    _init_properties_ipex_range_format_js_kt__6qn084();
    return rangeItemDTO;
  }
  var rangeItemDTO;
  function get_StaticComponentBuilder() {
    _init_properties_ipex_range_format_js_kt__6qn084();
    return staticComponentBuilder;
  }
  var staticComponentBuilder;
  function IPEXRangeFormatCatalog$_init_$ref_d52y62() {
    var l = function (p0) {
      return new IPEXRangeFormatCatalog(p0);
    };
    l.callableName = '<init>';
    return l;
  }
  function AmendableCatalog$_init_$ref_rulze3() {
    var l = function (p0) {
      return new AmendableCatalog(p0);
    };
    l.callableName = '<init>';
    return l;
  }
  function RangeItemDTO$_init_$ref_774wmu() {
    var l = function (p0, p1, p2, p3, p4) {
      return new RangeItemDTO(p0, p1, p2, p3, p4);
    };
    l.callableName = '<init>';
    return l;
  }
  function StaticComponentBuilder$_init_$ref_nnm7pj() {
    var l = function (p0) {
      return new StaticComponentBuilder(p0);
    };
    l.callableName = '<init>';
    return l;
  }
  var properties_initialized_ipex_range_format_js_kt_t3r77m;
  function _init_properties_ipex_range_format_js_kt__6qn084() {
    if (!properties_initialized_ipex_range_format_js_kt_t3r77m) {
      properties_initialized_ipex_range_format_js_kt_t3r77m = true;
      ipexRangeFormatCatalog = IPEXRangeFormatCatalog$_init_$ref_d52y62();
      amendableCatalog = AmendableCatalog$_init_$ref_rulze3();
      rangeItemDTO = RangeItemDTO$_init_$ref_774wmu();
      staticComponentBuilder = StaticComponentBuilder$_init_$ref_nnm7pj();
    }
  }
  function get_createCore() {
    _init_properties_kernel_js_kt__p0ka61();
    return createCore;
  }
  var createCore;
  function get_SceneSerializationUtil() {
    _init_properties_kernel_js_kt__p0ka61();
    return sceneSerializationUtil;
  }
  var sceneSerializationUtil;
  function Core() {
    _init_properties_kernel_js_kt__p0ka61();
    println('Using the Core() function to create an instance of Core is deprecated. Please use createCore() instead.');
    return new CoreImpl();
  }
  function CoreImpl$_init_$ref_yi8yhy() {
    var l = function (p0, p1, p2) {
      return new CoreImpl(p0, p1, p2);
    };
    l.callableName = '<init>';
    return l;
  }
  var properties_initialized_kernel_js_kt_yrqi4p;
  function _init_properties_kernel_js_kt__p0ka61() {
    if (!properties_initialized_kernel_js_kt_yrqi4p) {
      properties_initialized_kernel_js_kt_yrqi4p = true;
      createCore = CoreImpl$_init_$ref_yi8yhy();
      sceneSerializationUtil = SceneSerializationUtil_instance;
    }
  }
  function get_PlacementService() {
    _init_properties_stl_js_kt__e1niln();
    return PlacementService_0;
  }
  var PlacementService_0;
  function get_ReplaceUtils() {
    _init_properties_stl_js_kt__e1niln();
    return replaceUtils;
  }
  var replaceUtils;
  function get_ReplaceAssemblyPartUtils() {
    _init_properties_stl_js_kt__e1niln();
    return replaceAssemblyPartUtils;
  }
  var replaceAssemblyPartUtils;
  function get_SnapPlacementActor() {
    _init_properties_stl_js_kt__e1niln();
    return SnapPlacementActor_0;
  }
  var SnapPlacementActor_0;
  function get_ProppingSystem() {
    _init_properties_stl_js_kt__e1niln();
    return ProppingSystem_0;
  }
  var ProppingSystem_0;
  function get_ConnectorVisualizationSystem() {
    _init_properties_stl_js_kt__e1niln();
    return ConnectorVisualizationSystem_0;
  }
  var ConnectorVisualizationSystem_0;
  function get_ColliderVisualizationSystem() {
    _init_properties_stl_js_kt__e1niln();
    return ColliderVisualizationSystem_0;
  }
  var ColliderVisualizationSystem_0;
  function get_AutoAdaptHostZoneVisualizationSystem() {
    _init_properties_stl_js_kt__e1niln();
    return AutoAdaptHostZoneVisualizationSystem_0;
  }
  var AutoAdaptHostZoneVisualizationSystem_0;
  function get_FunctionalMarginVisualizationSystem() {
    _init_properties_stl_js_kt__e1niln();
    return FunctionalMarginVisualizationSystem_0;
  }
  var FunctionalMarginVisualizationSystem_0;
  function get_FunctionalZoneVisualization() {
    _init_properties_stl_js_kt__e1niln();
    return FunctionalZoneVisualization;
  }
  var FunctionalZoneVisualization;
  function get_DragProjectionPointVisualizationSystem() {
    _init_properties_stl_js_kt__e1niln();
    return DragProjectionPointVisualizationSystem_0;
  }
  var DragProjectionPointVisualizationSystem_0;
  function get_DragSystem() {
    _init_properties_stl_js_kt__e1niln();
    return DragSystem_0;
  }
  var DragSystem_0;
  function get_SnapCardinalDirectionsDragStrategy() {
    _init_properties_stl_js_kt__e1niln();
    return snapCardinalDirectionsDragStrategy;
  }
  var snapCardinalDirectionsDragStrategy;
  function get_SnapClosestDragStrategy() {
    _init_properties_stl_js_kt__e1niln();
    return snapClosestDragStrategy;
  }
  var snapClosestDragStrategy;
  function get_SnapClosestWithSubConnectorsDragStrategy() {
    _init_properties_stl_js_kt__e1niln();
    return snapClosestWithSubConnectorsDragStrategy;
  }
  var snapClosestWithSubConnectorsDragStrategy;
  function get_ResolveCollisionsDragStrategy() {
    _init_properties_stl_js_kt__e1niln();
    return resolveCollisionsDragStrategy;
  }
  var resolveCollisionsDragStrategy;
  function get_DrawDragGhostSystem() {
    _init_properties_stl_js_kt__e1niln();
    return drawDragGhostSystem;
  }
  var drawDragGhostSystem;
  function get_DragSurfaceNormalVisualizationSystem() {
    _init_properties_stl_js_kt__e1niln();
    return DragSurfaceNormalVisualizationSystem_0;
  }
  var DragSurfaceNormalVisualizationSystem_0;
  function get_DragSurfaceVisualizationSystem() {
    _init_properties_stl_js_kt__e1niln();
    return DragSurfaceVisualizationSystem_0;
  }
  var DragSurfaceVisualizationSystem_0;
  function get_DebugLineDrawingSystem() {
    _init_properties_stl_js_kt__e1niln();
    return DebugLineDrawingSystem_0;
  }
  var DebugLineDrawingSystem_0;
  function get_StandardSelectionService() {
    _init_properties_stl_js_kt__e1niln();
    return StandardSelectionService_0;
  }
  var StandardSelectionService_0;
  function get_AutoAdaptService() {
    _init_properties_stl_js_kt__e1niln();
    return AutoAdaptService_0;
  }
  var AutoAdaptService_0;
  function get_AlignmentConnectionCreationSystem() {
    _init_properties_stl_js_kt__e1niln();
    return AlignmentConnectionCreationSystem_0;
  }
  var AlignmentConnectionCreationSystem_0;
  function get_RoomService() {
    _init_properties_stl_js_kt__e1niln();
    return RoomService_0;
  }
  var RoomService_0;
  function get_RoomSystem() {
    _init_properties_stl_js_kt__e1niln();
    return RoomSystem_0;
  }
  var RoomSystem_0;
  function get_RoomComponentDeserializer() {
    _init_properties_stl_js_kt__e1niln();
    return roomComponentDeserializer;
  }
  var roomComponentDeserializer;
  function get_RoomConnectorConstants() {
    _init_properties_stl_js_kt__e1niln();
    return roomConnectorConstants;
  }
  var roomConnectorConstants;
  function get_StandardSelectionSystem() {
    _init_properties_stl_js_kt__e1niln();
    return StandardSelectionSystem;
  }
  var StandardSelectionSystem;
  function get_OutlineSystem() {
    _init_properties_stl_js_kt__e1niln();
    return OutlineSystemCtor;
  }
  var OutlineSystemCtor;
  function get_OutlineSelectedSystem() {
    _init_properties_stl_js_kt__e1niln();
    return OutlineSelectedSystemCtor;
  }
  var OutlineSelectedSystemCtor;
  function get_OutlineEntityGroupDeselectSystem() {
    _init_properties_stl_js_kt__e1niln();
    return OutlineEntityGroupDeselectSystem_0;
  }
  var OutlineEntityGroupDeselectSystem_0;
  function get_AllowedDoorPairsValidation() {
    _init_properties_stl_js_kt__e1niln();
    return AllowedDoorPairsValidation_0;
  }
  var AllowedDoorPairsValidation_0;
  function get_AlignmentPlane() {
    _init_properties_stl_js_kt__e1niln();
    return AlignmentPlane_0;
  }
  var AlignmentPlane_0;
  function get_AllowedNumberOfChildrenOfTypeValidation() {
    _init_properties_stl_js_kt__e1niln();
    return AllowedNumberOfChildrenOfTypeValidation_0;
  }
  var AllowedNumberOfChildrenOfTypeValidation_0;
  function get_DisallowSeparateRequiredHostsValidation() {
    _init_properties_stl_js_kt__e1niln();
    return disallowSeparateRequiredHostsValidation;
  }
  var disallowSeparateRequiredHostsValidation;
  function get_AssemblyInstructionsService() {
    _init_properties_stl_js_kt__e1niln();
    return AssemblyInstructionsService;
  }
  var AssemblyInstructionsService;
  function get_ICFDataService() {
    _init_properties_stl_js_kt__e1niln();
    return ICFDataService_0;
  }
  var ICFDataService_0;
  function get_PlacementResult() {
    _init_properties_stl_js_kt__e1niln();
    return PlacementResult_0;
  }
  var PlacementResult_0;
  function get_PlacementResultCompanion() {
    _init_properties_stl_js_kt__e1niln();
    return PlacementResultCompanion;
  }
  var PlacementResultCompanion;
  function get_FunctionalMarginValidation() {
    _init_properties_stl_js_kt__e1niln();
    return FunctionalMarginValidation_0;
  }
  var FunctionalMarginValidation_0;
  function get_PlacementZoneValidation() {
    _init_properties_stl_js_kt__e1niln();
    return placementZoneValidation;
  }
  var placementZoneValidation;
  function get_AlignmentLinesSystem() {
    _init_properties_stl_js_kt__e1niln();
    return ALIGNMENT_LINES_SYSTEM;
  }
  var ALIGNMENT_LINES_SYSTEM;
  function get_FunctionalMarginSystem() {
    _init_properties_stl_js_kt__e1niln();
    return FUNCTIONAL_MARGIN_SYSTEM;
  }
  var FUNCTIONAL_MARGIN_SYSTEM;
  function get_FunctionalMarginShapeComponent() {
    _init_properties_stl_js_kt__e1niln();
    return FunctionalMarginShapeComponent_0;
  }
  var FunctionalMarginShapeComponent_0;
  function get_FunctionalMarginComponent() {
    _init_properties_stl_js_kt__e1niln();
    return FunctionalMarginComponent_0;
  }
  var FunctionalMarginComponent_0;
  function get_RecommendedInitialPositionFromFloorComponent() {
    _init_properties_stl_js_kt__e1niln();
    return RecommendedInitialPositionFromFloorComponent_0;
  }
  var RecommendedInitialPositionFromFloorComponent_0;
  function get_PlacementZoneByHeightComponent() {
    _init_properties_stl_js_kt__e1niln();
    return PlacementZoneByHeightComponent_0;
  }
  var PlacementZoneByHeightComponent_0;
  function get_StlSystemIds() {
    _init_properties_stl_js_kt__e1niln();
    return stlSystemIds;
  }
  var stlSystemIds;
  function get_ReplacePartResult() {
    _init_properties_stl_js_kt__e1niln();
    return replacePartResultConstructor;
  }
  var replacePartResultConstructor;
  function get_AnyDragSurfaceProjector() {
    _init_properties_stl_js_kt__e1niln();
    return anyDragSurfaceProjector;
  }
  var anyDragSurfaceProjector;
  function get_XYPlaneProjector() {
    _init_properties_stl_js_kt__e1niln();
    return XYPlaneProjector_0;
  }
  var XYPlaneProjector_0;
  function get_DragSurfaceCanHostSelector() {
    _init_properties_stl_js_kt__e1niln();
    return DragSurfaceCanHostSelector_0;
  }
  var DragSurfaceCanHostSelector_0;
  function get_DragSurfaceCanHostWithAutoAdaptSelector() {
    _init_properties_stl_js_kt__e1niln();
    return DragSurfaceCanHostWithAutoAdaptSelector_0;
  }
  var DragSurfaceCanHostWithAutoAdaptSelector_0;
  function get_AutoAdaptProductSpecificationsSystem() {
    _init_properties_stl_js_kt__e1niln();
    return AutoAdaptProductSpecificationsSystem_0;
  }
  var AutoAdaptProductSpecificationsSystem_0;
  function get_LegacyCanvasTo3DDragConverterSystem() {
    _init_properties_stl_js_kt__e1niln();
    return LegacyCanvasTo3DDragConverterSystemConstructor;
  }
  var LegacyCanvasTo3DDragConverterSystemConstructor;
  function get_CanvasTo3DDragConverterSystem() {
    _init_properties_stl_js_kt__e1niln();
    return CanvasTo3DDragConverterSystem;
  }
  var CanvasTo3DDragConverterSystem;
  function get_EntityConnectorVisualizationSystem() {
    _init_properties_stl_js_kt__e1niln();
    return EntityConnectorVisualizationSystem_0;
  }
  var EntityConnectorVisualizationSystem_0;
  function get_EntityConnectorVisualizationComponent() {
    _init_properties_stl_js_kt__e1niln();
    return EntityConnectorVisualizationComponent_0;
  }
  var EntityConnectorVisualizationComponent_0;
  function get_Color() {
    _init_properties_stl_js_kt__e1niln();
    return Color_0;
  }
  var Color_0;
  function get_DefaultVisualizer() {
    _init_properties_stl_js_kt__e1niln();
    return DefaultVisualizer_0;
  }
  var DefaultVisualizer_0;
  function get_EntityColliderVisualizationSystem() {
    _init_properties_stl_js_kt__e1niln();
    return EntityColliderVisualizationSystem_0;
  }
  var EntityColliderVisualizationSystem_0;
  function get_EntityColliderVisualizationComponent() {
    _init_properties_stl_js_kt__e1niln();
    return EntityColliderVisualizationComponent_0;
  }
  var EntityColliderVisualizationComponent_0;
  function get_EntityCollisionVisualizationSystem() {
    _init_properties_stl_js_kt__e1niln();
    return EntityCollisionVisualizationSystem_0;
  }
  var EntityCollisionVisualizationSystem_0;
  function get_DecoratorComponent() {
    _init_properties_stl_js_kt__e1niln();
    return DecoratorComponent_0;
  }
  var DecoratorComponent_0;
  function get_CoreVisualization() {
    _init_properties_stl_js_kt__e1niln();
    return CoreVisualization_0;
  }
  var CoreVisualization_0;
  function get_ColoredOutlineSystem() {
    _init_properties_stl_js_kt__e1niln();
    return ColoredOutlineSystemConstructor;
  }
  var ColoredOutlineSystemConstructor;
  function get_ColoredOutlineComponent() {
    _init_properties_stl_js_kt__e1niln();
    return ColoredOutlineComponentConstructor;
  }
  var ColoredOutlineComponentConstructor;
  function get_DragExtensions() {
    _init_properties_stl_js_kt__e1niln();
    return dragExtensions;
  }
  var dragExtensions;
  function get_AutoAdaptFeature() {
    _init_properties_stl_js_kt__e1niln();
    return autoAdaptFeature;
  }
  var autoAdaptFeature;
  function get_AutoAdaptUtils() {
    _init_properties_stl_js_kt__e1niln();
    return autoAdaptUtils;
  }
  var autoAdaptUtils;
  function get_AutoAdaptSessionComponent() {
    _init_properties_stl_js_kt__e1niln();
    return autoAdaptSessionComponent;
  }
  var autoAdaptSessionComponent;
  function get_DragProjectionPointComponent() {
    _init_properties_stl_js_kt__e1niln();
    return dragProjectionPointComponentConstructor;
  }
  var dragProjectionPointComponentConstructor;
  function get_FunctionalZone() {
    _init_properties_stl_js_kt__e1niln();
    return functionalZoneCtor;
  }
  var functionalZoneCtor;
  function get_FunctionalZonesLocalComponent() {
    _init_properties_stl_js_kt__e1niln();
    return FunctionalZonesLocalComponentCtor;
  }
  var FunctionalZonesLocalComponentCtor;
  function get_DragState() {
    _init_properties_stl_js_kt__e1niln();
    return dragStateCtor;
  }
  var dragStateCtor;
  function get_DragStateComponent() {
    _init_properties_stl_js_kt__e1niln();
    return dragStateComponentCtor;
  }
  var dragStateComponentCtor;
  function get_ReplaceEntityEventComponent() {
    _init_properties_stl_js_kt__e1niln();
    return replacedWithAutoAdaptEventComponent;
  }
  var replacedWithAutoAdaptEventComponent;
  function get_LabelComponent() {
    _init_properties_stl_js_kt__e1niln();
    return LabelComponent_0;
  }
  var LabelComponent_0;
  function get_HigherPriorityAlignmentPostProcess() {
    _init_properties_stl_js_kt__e1niln();
    return HigherPriorityAlignmentPostProcessCtor;
  }
  var HigherPriorityAlignmentPostProcessCtor;
  function get_ValidationResultIds() {
    _init_properties_stl_js_kt__e1niln();
    return ValidationResultIdsObj;
  }
  var ValidationResultIdsObj;
  function get_RequiredConnectorsSatisfiedValidation() {
    _init_properties_stl_js_kt__e1niln();
    return RequiredConnectorsSatisfiedValidationCtor;
  }
  var RequiredConnectorsSatisfiedValidationCtor;
  function get_ValidationRuleIds() {
    _init_properties_stl_js_kt__e1niln();
    return ValidationRuleIdsObj;
  }
  var ValidationRuleIdsObj;
  function get_HostConnectorRotationValidation() {
    _init_properties_stl_js_kt__e1niln();
    return hostConnectorRotationValidation;
  }
  var hostConnectorRotationValidation;
  function get_SnapSorterBuilder() {
    _init_properties_stl_js_kt__e1niln();
    return sortBuilderCtor;
  }
  var sortBuilderCtor;
  function get_PlacementHelper() {
    _init_properties_stl_js_kt__e1niln();
    return placementHelperObject;
  }
  var placementHelperObject;
  function get_SpaceFinderUtils() {
    _init_properties_stl_js_kt__e1niln();
    return spaceFinderUtilsObject;
  }
  var spaceFinderUtilsObject;
  function ValidDragStrategyResult_0(entity, snapCandidate, warnings) {
    ValidDragStrategyResult.call(this, entity, snapCandidate, warnings);
  }
  function AutoAdaptDragStrategy_0(coreServices) {
    AutoAdaptDragStrategy.call(this, coreServices);
  }
  function HandleRotationSystem_0(coreServices) {
    _init_properties_stl_js_kt__e1niln();
    return new HandleRotationSystem(coreServices.validations, coreServices.sceneManager);
  }
  function DebugLogger_0(logPriorityLevel, exceptionPriorityLevel) {
    _init_properties_stl_js_kt__e1niln();
    return new DebugLogger(values()[logPriorityLevel], values()[exceptionPriorityLevel]);
  }
  function FunctionalZonesLocalToWorldSystem_0(entityManager) {
    FunctionalZonesLocalToWorldSystem.call(this, entityManager);
  }
  function PlacementService$_init_$ref_4ipsq3() {
    var l = function (p0, p1) {
      return new PlacementService(p0, p1);
    };
    l.callableName = '<init>';
    return l;
  }
  function SnapPlacementActor$_init_$ref_h9zo2z() {
    var l = function (p0, p1, p2) {
      return new SnapPlacementActor(p0, p1, p2);
    };
    l.callableName = '<init>';
    return l;
  }
  function ProppingSystem$_init_$ref_yjua67() {
    var l = function (p0, p1) {
      return new ProppingSystem(p0, p1);
    };
    l.callableName = '<init>';
    return l;
  }
  function ConnectorVisualizationSystem$_init_$ref_bhjn0h() {
    var l = function (p0) {
      return new ConnectorVisualizationSystem(p0);
    };
    l.callableName = '<init>';
    return l;
  }
  function ColliderVisualizationSystem$_init_$ref_iz3yxm() {
    var l = function (p0) {
      return new ColliderVisualizationSystem(p0);
    };
    l.callableName = '<init>';
    return l;
  }
  function AutoAdaptHostZoneVisualizationSystem$_init_$ref_nexzcp() {
    var l = function (p0) {
      return new AutoAdaptHostZoneVisualizationSystem(p0);
    };
    l.callableName = '<init>';
    return l;
  }
  function FunctionalMarginVisualizationSystem$_init_$ref_du8tkt() {
    var l = function (p0) {
      return new FunctionalMarginVisualizationSystem(p0);
    };
    l.callableName = '<init>';
    return l;
  }
  function FunctionalZoneVisualizationSystem$_init_$ref_z56su9() {
    var l = function (p0) {
      return new FunctionalZoneVisualizationSystem(p0);
    };
    l.callableName = '<init>';
    return l;
  }
  function DragProjectionPointVisualizationSystem$_init_$ref_iy9mhr() {
    var l = function (p0) {
      return new DragProjectionPointVisualizationSystem(p0);
    };
    l.callableName = '<init>';
    return l;
  }
  function DragSystem$_init_$ref_z2syyq() {
    var l = function (p0, p1) {
      return new DragSystem(p0, p1);
    };
    l.callableName = '<init>';
    return l;
  }
  function SnapCardinalDirectionsDragStrategy$_init_$ref_ouuluo() {
    var l = function (p0) {
      return new SnapCardinalDirectionsDragStrategy(p0);
    };
    l.callableName = '<init>';
    return l;
  }
  function SnapClosestDragStrategy$_init_$ref_un3qp() {
    var l = function (p0) {
      return new SnapClosestDragStrategy(p0);
    };
    l.callableName = '<init>';
    return l;
  }
  function SnapClosestWithSubConnectorsDragStrategy$_init_$ref_20uk5v() {
    var l = function (p0) {
      return new SnapClosestWithSubConnectorsDragStrategy(p0);
    };
    l.callableName = '<init>';
    return l;
  }
  function ResolveCollisionsDragStrategy$_init_$ref_cuay8f() {
    var l = function (p0, p1) {
      return new ResolveCollisionsDragStrategy(p0, p1);
    };
    l.callableName = '<init>';
    return l;
  }
  function DrawDragGhostSystem$_init_$ref_www5q7() {
    var l = function (p0, p1, p2, p3, p4) {
      return new DrawDragGhostSystem(p0, p1, p2, p3, p4);
    };
    l.callableName = '<init>';
    return l;
  }
  function DragSurfaceNormalVisualizationSystem$_init_$ref_miyxm6() {
    var l = function (p0) {
      return new DragSurfaceNormalVisualizationSystem(p0);
    };
    l.callableName = '<init>';
    return l;
  }
  function DragSurfaceVisualizationSystem$_init_$ref_h43d11() {
    var l = function (p0) {
      return new DragSurfaceVisualizationSystem(p0);
    };
    l.callableName = '<init>';
    return l;
  }
  function DebugLineDrawingSystem$_init_$ref_kvzwwv() {
    var l = function (p0) {
      return new DebugLineDrawingSystem(p0);
    };
    l.callableName = '<init>';
    return l;
  }
  function StandardSelectionService$_init_$ref_k0v6bl() {
    var l = function (p0) {
      return new StandardSelectionService(p0);
    };
    l.callableName = '<init>';
    return l;
  }
  function AutoAdaptService$_init_$ref_k4m925() {
    var l = function (p0) {
      return new AutoAdaptService(p0);
    };
    l.callableName = '<init>';
    return l;
  }
  function AlignmentConnectionCreationSystem$_init_$ref_ta0hcm() {
    var l = function (p0) {
      return new AlignmentConnectionCreationSystem(p0);
    };
    l.callableName = '<init>';
    return l;
  }
  function RoomService$_init_$ref_14lqff() {
    var l = function (p0, p1) {
      return new RoomService(p0, p1);
    };
    l.callableName = '<init>';
    return l;
  }
  function RoomSystem$_init_$ref_mxcny3() {
    var l = function (p0, p1) {
      return new RoomSystem(p0, p1);
    };
    l.callableName = '<init>';
    return l;
  }
  function RoomComponentDeserializer$_init_$ref_ocu3f4() {
    var l = function () {
      return new RoomComponentDeserializer();
    };
    l.callableName = '<init>';
    return l;
  }
  function StandardSelectionSystem$_init_$ref_nkymih() {
    var l = function (p0) {
      return StandardSelectionSystemFromCoreServices(p0);
    };
    l.callableName = '<init>';
    return l;
  }
  function OutlineSystem$_init_$ref_a0oop8() {
    var l = function () {
      return new OutlineSystem();
    };
    l.callableName = '<init>';
    return l;
  }
  function OutlineSelectedSystem$_init_$ref_b6zwpz() {
    var l = function () {
      return new OutlineSelectedSystem();
    };
    l.callableName = '<init>';
    return l;
  }
  function OutlineEntityGroupDeselectSystem$_init_$ref_jrsydb() {
    var l = function (p0) {
      return new OutlineEntityGroupDeselectSystem(p0);
    };
    l.callableName = '<init>';
    return l;
  }
  function AllowedDoorPairsValidation$_init_$ref_tv5wjt() {
    var l = function () {
      return new AllowedDoorPairsValidation();
    };
    l.callableName = '<init>';
    return l;
  }
  function AlignmentPlane$_init_$ref_i3c9l8() {
    var l = function (p0, p1, p2) {
      return new AlignmentPlane(p0, p1, p2);
    };
    l.callableName = '<init>';
    return l;
  }
  function AllowedNumberOfChildrenOfTypeValidation$_init_$ref_sj8e0k() {
    var l = function (p0, p1, p2) {
      return new AllowedNumberOfChildrenOfTypeValidation(p0, p1, p2);
    };
    l.callableName = '<init>';
    return l;
  }
  function DisallowSeparateRequiredHostsValidation$_init_$ref_9l13xe() {
    var l = function (p0, p1) {
      return new DisallowSeparateRequiredHostsValidation(p0, p1);
    };
    l.callableName = '<init>';
    return l;
  }
  function AssemblyInstructionsServiceImpl$_init_$ref_60674r() {
    var l = function () {
      return new AssemblyInstructionsServiceImpl();
    };
    l.callableName = '<init>';
    return l;
  }
  function ICFDataService$_init_$ref_ewcpkq() {
    var l = function (p0) {
      return new ICFDataService(p0);
    };
    l.callableName = '<init>';
    return l;
  }
  function PlacementResult$_init_$ref_vv0umb() {
    var l = function (p0, p1, p2) {
      return new PlacementResult(p0, p1, p2);
    };
    l.callableName = '<init>';
    return l;
  }
  function FunctionalMarginValidation$_init_$ref_cl4qmd() {
    var l = function (p0, p1) {
      return new FunctionalMarginValidation(p0, p1);
    };
    l.callableName = '<init>';
    return l;
  }
  function PlacementZoneValidation$_init_$ref_xzv9i3() {
    var l = function () {
      return new PlacementZoneValidation();
    };
    l.callableName = '<init>';
    return l;
  }
  function AlignmentLinesSystem$_init_$ref_2vzu7a() {
    var l = function (p0, p1, p2, p3, p4, p5, p6) {
      return new AlignmentLinesSystem(p0, p1, p2, p3, p4, p5, p6);
    };
    l.callableName = '<init>';
    return l;
  }
  function FunctionalMarginSystem$_init_$ref_nm9ef9() {
    var l = function () {
      return new FunctionalMarginSystem();
    };
    l.callableName = '<init>';
    return l;
  }
  function FunctionalMarginShapeComponent$_init_$ref_ukwgzs() {
    var l = function (p0) {
      return new FunctionalMarginShapeComponent(p0);
    };
    l.callableName = '<init>';
    return l;
  }
  function FunctionalMarginComponent$_init_$ref_djhkft() {
    var l = function (p0) {
      return new FunctionalMarginComponent(p0);
    };
    l.callableName = '<init>';
    return l;
  }
  function RecommendedInitialPositionFromFloorComponent$_init_$ref_dyzfs8() {
    var l = function (p0) {
      return new RecommendedInitialPositionFromFloorComponent(p0);
    };
    l.callableName = '<init>';
    return l;
  }
  function PlacementZoneByHeightComponent$_init_$ref_1zq8h5() {
    var l = function (p0, p1) {
      return new PlacementZoneByHeightComponent(p0, p1);
    };
    l.callableName = '<init>';
    return l;
  }
  function ReplacePartResult$_init_$ref_snfbmn() {
    var l = function (p0, p1, p2, p3, p4, p5) {
      return new ReplacePartResult(p0, p1, p2, p3, p4, p5);
    };
    l.callableName = '<init>';
    return l;
  }
  function anyDragSurfaceProjector$lambda(coreServices, dragSelector) {
    _init_properties_stl_js_kt__e1niln();
    return AnyDragSurfaceProjectorFromCoreServices(coreServices, dragSelector == null ? new DragSurfaceOnlyRoomSelector() : dragSelector);
  }
  function XYPlaneProjector$_init_$ref_yhqdrw() {
    var l = function () {
      return new XYPlaneProjector();
    };
    l.callableName = '<init>';
    return l;
  }
  function DragSurfaceCanHostSelector$_init_$ref_vj8lw9() {
    var l = function () {
      return new DragSurfaceCanHostSelector();
    };
    l.callableName = '<init>';
    return l;
  }
  function DragSurfaceCanHostWithAutoAdaptSelector$_init_$ref_xz7lxk() {
    var l = function (p0) {
      return new DragSurfaceCanHostWithAutoAdaptSelector(p0);
    };
    l.callableName = '<init>';
    return l;
  }
  function AutoAdaptProductSpecificationsSystem$_init_$ref_vn5aie() {
    var l = function (p0) {
      return new AutoAdaptProductSpecificationsSystem(p0);
    };
    l.callableName = '<init>';
    return l;
  }
  function LegacyCanvasTo3DDragConverterSystemConstructor$lambda(coreServices, projector) {
    _init_properties_stl_js_kt__e1niln();
    return new LegacyCanvasTo3DDragConverterSystem(coreServices.entityManager, coreServices.sceneManager, projector);
  }
  function CanvasTo3DDragConverterSystem$_init_$ref_9wy4k2() {
    var l = function (p0, p1) {
      return CanvasTo3DDragConverterSystemFromCoreServices(p0, p1);
    };
    l.callableName = '<init>';
    return l;
  }
  function EntityConnectorVisualizationSystem$_init_$ref_5xr5ng() {
    var l = function (p0, p1) {
      return new EntityConnectorVisualizationSystem(p0, p1);
    };
    l.callableName = '<init>';
    return l;
  }
  function EntityConnectorVisualizationComponent$_init_$ref_jbgyim() {
    var l = function (p0) {
      return new EntityConnectorVisualizationComponent(p0);
    };
    l.callableName = '<init>';
    return l;
  }
  function Color$_init_$ref_hzu4wy() {
    var l = function (p0, p1, p2, p3) {
      return new Color(p0, p1, p2, p3);
    };
    l.callableName = '<init>';
    return l;
  }
  function DefaultVisualizer$_init_$ref_c8298m() {
    var l = function (p0, p1) {
      return new DefaultVisualizer(p0, p1);
    };
    l.callableName = '<init>';
    return l;
  }
  function EntityColliderVisualizationSystem$_init_$ref_kjeuy1() {
    var l = function (p0, p1) {
      return new EntityColliderVisualizationSystem(p0, p1);
    };
    l.callableName = '<init>';
    return l;
  }
  function EntityColliderVisualizationComponent$_init_$ref_fnoiaz() {
    var l = function (p0, p1, p2) {
      return new EntityColliderVisualizationComponent(p0, p1, p2);
    };
    l.callableName = '<init>';
    return l;
  }
  function EntityCollisionVisualizationSystem$_init_$ref_k8ky2n() {
    var l = function (p0) {
      return new EntityCollisionVisualizationSystem(p0);
    };
    l.callableName = '<init>';
    return l;
  }
  function DecoratorComponent$_init_$ref_j03x2b() {
    var l = function (p0, p1, p2, p3, p4) {
      return new DecoratorComponent(p0, p1, p2, p3, p4);
    };
    l.callableName = '<init>';
    return l;
  }
  function CoreVisualization$_init_$ref_sop7eo() {
    var l = function (p0, p1, p2) {
      return new CoreVisualization(p0, p1, p2);
    };
    l.callableName = '<init>';
    return l;
  }
  function ColoredOutlineSystem$_init_$ref_pg9el2() {
    var l = function () {
      return new ColoredOutlineSystem();
    };
    l.callableName = '<init>';
    return l;
  }
  function ColoredOutlineComponent$_init_$ref_7pktoo() {
    var l = function (p0, p1, p2) {
      return new ColoredOutlineComponent(p0, p1, p2);
    };
    l.callableName = '<init>';
    return l;
  }
  function AutoAdaptSessionComponent$_init_$ref_wk48zv() {
    var l = function () {
      return new AutoAdaptSessionComponent();
    };
    l.callableName = '<init>';
    return l;
  }
  function DragProjectionPointComponent$_init_$ref_bdpsob() {
    var l = function (p0) {
      return new DragProjectionPointComponent(p0);
    };
    l.callableName = '<init>';
    return l;
  }
  function FunctionalZone$_init_$ref_xj34xi() {
    var l = function (p0, p1, p2) {
      return new FunctionalZone(p0, p1, p2);
    };
    l.callableName = '<init>';
    return l;
  }
  function FunctionalZonesLocalComponent$_init_$ref_4xbtox() {
    var l = function (p0) {
      return new FunctionalZonesLocalComponent(p0);
    };
    l.callableName = '<init>';
    return l;
  }
  function DragState$_init_$ref_k1ow1k() {
    var l = function (p0, p1, p2, p3, p4, p5, p6, p7) {
      return new DragState(p0, p1, p2, p3, p4, p5, p6, p7);
    };
    l.callableName = '<init>';
    return l;
  }
  function DragStateComponent$_init_$ref_bylfol() {
    var l = function (p0) {
      return new DragStateComponent(p0);
    };
    l.callableName = '<init>';
    return l;
  }
  function ReplacedWithAutoAdaptEventComponent$_init_$ref_nm7pmt() {
    var l = function (p0) {
      return new ReplacedWithAutoAdaptEventComponent(p0);
    };
    l.callableName = '<init>';
    return l;
  }
  function LabelComponent$_init_$ref_529rj8() {
    var l = function (p0) {
      return new LabelComponent(p0);
    };
    l.callableName = '<init>';
    return l;
  }
  function HigherPriorityAlignmentPostProcess$_init_$ref_fytm9y() {
    var l = function (p0) {
      return new HigherPriorityAlignmentPostProcess(p0);
    };
    l.callableName = '<init>';
    return l;
  }
  function RequiredConnectorsSatisfiedValidation$_init_$ref_dsrkbj() {
    var l = function () {
      return new RequiredConnectorsSatisfiedValidation();
    };
    l.callableName = '<init>';
    return l;
  }
  function HostConnectorRotationValidation$_init_$ref_rmkrhl() {
    var l = function () {
      return new HostConnectorRotationValidation();
    };
    l.callableName = '<init>';
    return l;
  }
  function SnapSorterBuilder$_init_$ref_vyls5d() {
    var l = function () {
      return new SnapSorterBuilder();
    };
    l.callableName = '<init>';
    return l;
  }
  var properties_initialized_stl_js_kt_pepimr;
  function _init_properties_stl_js_kt__e1niln() {
    if (!properties_initialized_stl_js_kt_pepimr) {
      properties_initialized_stl_js_kt_pepimr = true;
      PlacementService_0 = PlacementService$_init_$ref_4ipsq3();
      replaceUtils = ReplaceUtils_instance;
      replaceAssemblyPartUtils = ReplaceAssemblyPartUtils_getInstance();
      SnapPlacementActor_0 = SnapPlacementActor$_init_$ref_h9zo2z();
      ProppingSystem_0 = ProppingSystem$_init_$ref_yjua67();
      ConnectorVisualizationSystem_0 = ConnectorVisualizationSystem$_init_$ref_bhjn0h();
      ColliderVisualizationSystem_0 = ColliderVisualizationSystem$_init_$ref_iz3yxm();
      AutoAdaptHostZoneVisualizationSystem_0 = AutoAdaptHostZoneVisualizationSystem$_init_$ref_nexzcp();
      FunctionalMarginVisualizationSystem_0 = FunctionalMarginVisualizationSystem$_init_$ref_du8tkt();
      FunctionalZoneVisualization = FunctionalZoneVisualizationSystem$_init_$ref_z56su9();
      DragProjectionPointVisualizationSystem_0 = DragProjectionPointVisualizationSystem$_init_$ref_iy9mhr();
      DragSystem_0 = DragSystem$_init_$ref_z2syyq();
      snapCardinalDirectionsDragStrategy = SnapCardinalDirectionsDragStrategy$_init_$ref_ouuluo();
      snapClosestDragStrategy = SnapClosestDragStrategy$_init_$ref_un3qp();
      snapClosestWithSubConnectorsDragStrategy = SnapClosestWithSubConnectorsDragStrategy$_init_$ref_20uk5v();
      resolveCollisionsDragStrategy = ResolveCollisionsDragStrategy$_init_$ref_cuay8f();
      drawDragGhostSystem = DrawDragGhostSystem$_init_$ref_www5q7();
      DragSurfaceNormalVisualizationSystem_0 = DragSurfaceNormalVisualizationSystem$_init_$ref_miyxm6();
      DragSurfaceVisualizationSystem_0 = DragSurfaceVisualizationSystem$_init_$ref_h43d11();
      DebugLineDrawingSystem_0 = DebugLineDrawingSystem$_init_$ref_kvzwwv();
      StandardSelectionService_0 = StandardSelectionService$_init_$ref_k0v6bl();
      AutoAdaptService_0 = AutoAdaptService$_init_$ref_k4m925();
      AlignmentConnectionCreationSystem_0 = AlignmentConnectionCreationSystem$_init_$ref_ta0hcm();
      RoomService_0 = RoomService$_init_$ref_14lqff();
      RoomSystem_0 = RoomSystem$_init_$ref_mxcny3();
      roomComponentDeserializer = RoomComponentDeserializer$_init_$ref_ocu3f4();
      roomConnectorConstants = RoomConnectorConstants_getInstance();
      StandardSelectionSystem = StandardSelectionSystem$_init_$ref_nkymih();
      OutlineSystemCtor = OutlineSystem$_init_$ref_a0oop8();
      OutlineSelectedSystemCtor = OutlineSelectedSystem$_init_$ref_b6zwpz();
      OutlineEntityGroupDeselectSystem_0 = OutlineEntityGroupDeselectSystem$_init_$ref_jrsydb();
      AllowedDoorPairsValidation_0 = AllowedDoorPairsValidation$_init_$ref_tv5wjt();
      AlignmentPlane_0 = AlignmentPlane$_init_$ref_i3c9l8();
      AllowedNumberOfChildrenOfTypeValidation_0 = AllowedNumberOfChildrenOfTypeValidation$_init_$ref_sj8e0k();
      disallowSeparateRequiredHostsValidation = DisallowSeparateRequiredHostsValidation$_init_$ref_9l13xe();
      AssemblyInstructionsService = AssemblyInstructionsServiceImpl$_init_$ref_60674r();
      ICFDataService_0 = ICFDataService$_init_$ref_ewcpkq();
      PlacementResult_0 = PlacementResult$_init_$ref_vv0umb();
      PlacementResultCompanion = Companion_instance;
      FunctionalMarginValidation_0 = FunctionalMarginValidation$_init_$ref_cl4qmd();
      placementZoneValidation = PlacementZoneValidation$_init_$ref_xzv9i3();
      ALIGNMENT_LINES_SYSTEM = AlignmentLinesSystem$_init_$ref_2vzu7a();
      FUNCTIONAL_MARGIN_SYSTEM = FunctionalMarginSystem$_init_$ref_nm9ef9();
      FunctionalMarginShapeComponent_0 = FunctionalMarginShapeComponent$_init_$ref_ukwgzs();
      FunctionalMarginComponent_0 = FunctionalMarginComponent$_init_$ref_djhkft();
      RecommendedInitialPositionFromFloorComponent_0 = RecommendedInitialPositionFromFloorComponent$_init_$ref_dyzfs8();
      PlacementZoneByHeightComponent_0 = PlacementZoneByHeightComponent$_init_$ref_1zq8h5();
      stlSystemIds = StlSystemIds_instance;
      replacePartResultConstructor = ReplacePartResult$_init_$ref_snfbmn();
      anyDragSurfaceProjector = anyDragSurfaceProjector$lambda;
      XYPlaneProjector_0 = XYPlaneProjector$_init_$ref_yhqdrw();
      DragSurfaceCanHostSelector_0 = DragSurfaceCanHostSelector$_init_$ref_vj8lw9();
      DragSurfaceCanHostWithAutoAdaptSelector_0 = DragSurfaceCanHostWithAutoAdaptSelector$_init_$ref_xz7lxk();
      AutoAdaptProductSpecificationsSystem_0 = AutoAdaptProductSpecificationsSystem$_init_$ref_vn5aie();
      LegacyCanvasTo3DDragConverterSystemConstructor = LegacyCanvasTo3DDragConverterSystemConstructor$lambda;
      CanvasTo3DDragConverterSystem = CanvasTo3DDragConverterSystem$_init_$ref_9wy4k2();
      EntityConnectorVisualizationSystem_0 = EntityConnectorVisualizationSystem$_init_$ref_5xr5ng();
      EntityConnectorVisualizationComponent_0 = EntityConnectorVisualizationComponent$_init_$ref_jbgyim();
      Color_0 = Color$_init_$ref_hzu4wy();
      DefaultVisualizer_0 = DefaultVisualizer$_init_$ref_c8298m();
      EntityColliderVisualizationSystem_0 = EntityColliderVisualizationSystem$_init_$ref_kjeuy1();
      EntityColliderVisualizationComponent_0 = EntityColliderVisualizationComponent$_init_$ref_fnoiaz();
      EntityCollisionVisualizationSystem_0 = EntityCollisionVisualizationSystem$_init_$ref_k8ky2n();
      DecoratorComponent_0 = DecoratorComponent$_init_$ref_j03x2b();
      CoreVisualization_0 = CoreVisualization$_init_$ref_sop7eo();
      ColoredOutlineSystemConstructor = ColoredOutlineSystem$_init_$ref_pg9el2();
      ColoredOutlineComponentConstructor = ColoredOutlineComponent$_init_$ref_7pktoo();
      dragExtensions = Companion_getInstance_3();
      autoAdaptFeature = AutoAdaptFeature_instance;
      autoAdaptUtils = AutoAdaptUtils_getInstance();
      autoAdaptSessionComponent = AutoAdaptSessionComponent$_init_$ref_wk48zv();
      dragProjectionPointComponentConstructor = DragProjectionPointComponent$_init_$ref_bdpsob();
      functionalZoneCtor = FunctionalZone$_init_$ref_xj34xi();
      FunctionalZonesLocalComponentCtor = FunctionalZonesLocalComponent$_init_$ref_4xbtox();
      dragStateCtor = DragState$_init_$ref_k1ow1k();
      dragStateComponentCtor = DragStateComponent$_init_$ref_bylfol();
      replacedWithAutoAdaptEventComponent = ReplacedWithAutoAdaptEventComponent$_init_$ref_nm7pmt();
      LabelComponent_0 = LabelComponent$_init_$ref_529rj8();
      HigherPriorityAlignmentPostProcessCtor = HigherPriorityAlignmentPostProcess$_init_$ref_fytm9y();
      ValidationResultIdsObj = ValidationResultIds_instance;
      RequiredConnectorsSatisfiedValidationCtor = RequiredConnectorsSatisfiedValidation$_init_$ref_dsrkbj();
      ValidationRuleIdsObj = ValidationRuleIds_instance;
      hostConnectorRotationValidation = HostConnectorRotationValidation$_init_$ref_rmkrhl();
      sortBuilderCtor = SnapSorterBuilder$_init_$ref_vyls5d();
      placementHelperObject = PlacementHelper_getInstance();
      spaceFinderUtilsObject = SpaceFinderUtils_getInstance();
    }
  }
  function get_arrangeExtensions() {
    _init_properties_test_helpers_js_kt__3l78uy();
    return arrangeExtensions;
  }
  var arrangeExtensions;
  function get_placementExtensions() {
    _init_properties_test_helpers_js_kt__3l78uy();
    return placementExtensions;
  }
  var placementExtensions;
  function get_autoAdaptExtensions() {
    _init_properties_test_helpers_js_kt__3l78uy();
    return autoAdaptExtensions;
  }
  var autoAdaptExtensions;
  function get_CountSystem() {
    _init_properties_test_helpers_js_kt__3l78uy();
    return countSystem;
  }
  var countSystem;
  function get_RoomGeneratorUtils() {
    _init_properties_test_helpers_js_kt__3l78uy();
    return roomGeneratorUtils;
  }
  var roomGeneratorUtils;
  function CountSystem$_init_$ref_315rnd() {
    var l = function () {
      return new CountSystem();
    };
    l.callableName = '<init>';
    return l;
  }
  var properties_initialized_test_helpers_js_kt_u517pg;
  function _init_properties_test_helpers_js_kt__3l78uy() {
    if (!properties_initialized_test_helpers_js_kt_u517pg) {
      properties_initialized_test_helpers_js_kt_u517pg = true;
      arrangeExtensions = ArrangeExtensions_instance;
      placementExtensions = PlacementExtensions_instance;
      autoAdaptExtensions = AutoAdaptExtensions_instance;
      countSystem = CountSystem$_init_$ref_315rnd();
      roomGeneratorUtils = RoomGeneratorUtils_instance;
    }
  }
  //region block: post-declaration
  defineProp(protoOf(UnserializableEntityComponent_0), 'serializable', function () {
    return this.z1k();
  });
  defineProp(protoOf(UnserializableEntityComponent_0), 'doStoreInSnapshot', function () {
    return this.a1l();
  });
  //endregion
  //region block: exports
  function $jsExportAll$(_) {
    defineProp(_, 'ConnectorType', get_ConnectorType);
    defineProp(_, 'Vector', get_Vector);
    defineProp(_, 'Margin', get_Margin);
    defineProp(_, 'Size', get_Size);
    defineProp(_, 'ModelTransform', get_ModelTransform);
    defineProp(_, 'EntityManagerImpl', get_EntityManagerImpl);
    defineProp(_, 'Ray', get_Ray);
    defineProp(_, 'Transform', get_Transform);
    defineProp(_, 'Quaternion', get_Quaternion);
    defineProp(_, 'Degrees', get_Degrees);
    defineProp(_, 'Radians', get_Radians);
    defineProp(_, 'Face', get_Face);
    defineProp(_, 'Cuboid', get_Cuboid);
    defineProp(_, 'PolyhedronGroup', get_PolyhedronGroup);
    defineProp(_, 'ConvexPolyhedron', get_ConvexPolyhedron);
    defineProp(_, 'AxisAlignedBox', get_AxisAlignedBox);
    defineProp(_, 'ProductSpecification', get_ProductSpecification);
    defineProp(_, 'ValidationResultFail', get_ValidationResultFail);
    defineProp(_, 'ValidationResultWarning', get_ValidationResultWarning);
    defineProp(_, 'CollisionValidationResult', get_CollisionValidationResult);
    defineProp(_, 'CollisionValidation', get_CollisionValidation);
    defineProp(_, 'PartPair', get_PartPair);
    defineProp(_, 'ProductCatalogFunctions', get_ProductCatalogFunctions);
    defineProp(_, 'ColliderShapeComponent', get_ColliderShapeComponent);
    defineProp(_, 'Polygon', get_Polygon);
    defineProp(_, 'Plane', get_Plane);
    defineProp(_, 'DebugSurfacesComponent', get_DebugSurfacesComponent);
    defineProp(_, 'DisplayNameComponent', get_DisplayNameComponent);
    defineProp(_, 'DisabledConnectorsComponent', get_DisabledConnectorsComponent);
    defineProp(_, 'ModelInfoComponent', get_ModelInfoComponent);
    defineProp(_, 'ModelTransformComponent', get_ModelTransformComponent);
    defineProp(_, 'RelativeConnectorRepositioner', get_RelativeConnectorRepositioner);
    defineProp(_, 'RelativeConnectorData', get_RelativeConnectorData);
    defineProp(_, 'RelationOriginAlongX', get_RelationOriginAlongX);
    defineProp(_, 'RelationOriginAlongY', get_RelationOriginAlongY);
    defineProp(_, 'RelationOriginAlongZ', get_RelationOriginAlongZ);
    defineProp(_, 'RelationOrigin', get_RelationOrigin);
    defineProp(_, 'RelativeBoxOffset', get_RelativeBoxOffset);
    defineProp(_, 'PointConnector', get_PointConnector);
    defineProp(_, 'PointSeriesConnector', get_PointSeriesConnector);
    defineProp(_, 'PointSeriesSubConnector', get_PointSeriesSubConnector);
    defineProp(_, 'EdgeConnector', get_EdgeConnector);
    defineProp(_, 'SurfaceConnector', get_SurfaceConnector);
    defineProp(_, 'MathUtils', get_MathUtils);
    defineProp(_, 'ViewerDragEventComponent', get_ViewerDragEventComponent);
    defineProp(_, 'LogLevel', get_LogLevel);
    defineProp(_, 'RotationDegreeOfFreedom', get_RotationDegreeOfFreedom);
    defineProp(_, 'PolyhedronUtils', get_PolyhedronUtils);
    defineProp(_, 'RaycastResult', get_RaycastResult);
    defineProp(_, 'ApiSystemIds', get_ApiSystemIds);
    defineProp(_, 'GuestConnectionsComponent', get_GuestConnectionsComponent);
    defineProp(_, 'HostConnectionsComponent', get_HostConnectionsComponent);
    defineProp(_, 'DragSurfacesComponent', get_DragSurfacesComponent);
    defineProp(_, 'OutlineableComponent', get_OutlineableComponent);
    defineProp(_, 'DragSurface', get_DragSurface);
    defineProp(_, 'AutomaticGroupBuilderSystem', get_AutomaticGroupBuilderSystem);
    defineProp(_, 'ManualGroupConnectorValidation', get_ManualGroupConnectorValidation);
    defineProp(_, 'AssemblyStructureComponent', get_AssemblyStructureComponent);
    defineProp(_, 'RestrictAllowedRequiredHostsComponent', get_RestrictAllowedRequiredHostsComponent);
    defineProp(_, 'ManualEntityGroupBuilderService', get_ManualEntityGroupBuilderService);
    defineProp(_, 'DebugLine', get_DebugLine);
    defineProp(_, 'DebugLinesComponent', get_DebugLinesComponent);
    defineProp(_, 'ValidationFail', get_ValidationFail);
    defineProp(_, 'ValidationWarning', get_ValidationWarning);
    defineProp(_, 'AxisAlignedBoxUtils', get_AxisAlignedBoxUtils);
    defineProp(_, 'VectorConstants', get_VectorConstants);
    defineProp(_, 'IsLoadingSnapshotComponent', get_IsLoadingSnapshotComponent);
    defineProp(_, 'SnapshotIgnoreComponent', get_SnapshotIgnoreComponent);
    defineProp(_, 'ChildConnectionValidation', get_ChildConnectionValidation);
    _.quaternionFromEuler = quaternionFromEuler;
    _.UnserializableEntityComponent = UnserializableEntityComponent_0;
    _.createDragType = createDragType;
    _.mockLoadedModelInfoComponent = mockLoadedModelInfoComponent;
    defineProp(_, 'SelectableComponent', get_SelectableComponent);
    defineProp(_, 'DraggableComponent', get_DraggableComponent);
    defineProp(_, 'SnapRootComponent', get_SnapRootComponent);
    defineProp(_, 'HistoryEvent', get_HistoryEvent);
    defineProp(_, 'HistoryChangedEventComponent', get_HistoryChangedEventComponent);
    defineProp(_, 'WorldSpaceDragEventComponent', get_WorldSpaceDragEventComponent);
    defineProp(_, 'ClickEventComponent', get_ClickEventComponent);
    defineProp(_, 'LocalTransformComponent', get_LocalTransformComponent);
    defineProp(_, 'ConnectorsComponent', get_ConnectorsComponent);
    defineProp(_, 'ChildComponent', get_ChildComponent);
    defineProp(_, 'ParentComponent', get_ParentComponent);
    defineProp(_, 'ViewerObjectComponent', get_ViewerObjectComponent);
    defineProp(_, 'ConnectionRootComponent', get_ConnectionRootComponent);
    defineProp(_, 'ProductPartComponent', get_ProductPartComponent);
    defineProp(_, 'WorldTransformComponent', get_WorldTransformComponent);
    defineProp(_, 'ComponentIds', get_ComponentIds);
    defineProp(_, 'ComponentIdSpan', get_ComponentIdSpan);
    defineProp(_, 'TemplateDataComponent', get_TemplateDataComponent);
    defineProp(_, 'RelativeConnectorsComponent', get_RelativeConnectorsComponent);
    defineProp(_, 'AssemblyPartsComponent', get_AssemblyPartsComponent);
    defineProp(_, 'ViewerComponent', get_ViewerComponent);
    defineProp(_, 'ProductComponent', get_ProductComponent);
    _.SelectedComponent = SelectedComponent;
    _.SceneReloading = SceneReloading;
    _.RenderedComponent = RenderedComponent;
    _.InSceneComponent = InSceneComponent;
    _.StaticComponent = StaticComponent;
    var $com = _.com || (_.com = {});
    var $com$ikea = $com.ikea || ($com.ikea = {});
    var $com$ikea$core = $com$ikea.core || ($com$ikea.core = {});
    var $com$ikea$core$debug = $com$ikea$core.debug || ($com$ikea$core.debug = {});
    $com$ikea$core$debug._CoreDebug = _CoreDebug;
    defineProp(_, 'ColliderUtils', get_ColliderUtils);
    defineProp(_, 'CollisionUtils', get_CollisionUtils);
    defineProp(_, 'ComponentUtils', get_ComponentUtils);
    defineProp(_, 'ConnectionUtils', get_ConnectionUtils);
    defineProp(_, 'ConnectorUtils', get_ConnectorUtils);
    defineProp(_, 'EntityGroupUtils', get_EntityGroupUtils);
    defineProp(_, 'HierarchyUtils', get_HierarchyUtils);
    defineProp(_, 'MeasurementUtils', get_MeasurementUtils);
    defineProp(_, 'ModelUtils', get_ModelUtils);
    defineProp(_, 'ProductUtils', get_ProductUtils);
    defineProp(_, 'RaycastUtils', get_RaycastUtils);
    defineProp(_, 'SnapActionCandidateSortAndSelectStrategies', get_SnapActionCandidateSortAndSelectStrategies);
    defineProp(_, 'SnapUtils', get_SnapUtils);
    defineProp(_, 'TransformUtils', get_TransformUtils);
    defineProp(_, 'OutlinedComponent', get_OutlinedComponent);
    defineProp(_, 'OutlineBlockingComponent', get_OutlineBlockingComponent);
    defineProp(_, 'AutoAdaptHostComponent', get_AutoAdaptHostComponent);
    defineProp(_, 'AutoAdaptGuestComponent', get_AutoAdaptGuestComponent);
    defineProp(_, 'AutoAdaptVariantComponent', get_AutoAdaptVariantComponent);
    defineProp(_, 'ForceAutoAdaptWhenParentIsDraggedComponent', get_ForceAutoAdaptWhenParentIsDraggedComponent);
    defineProp(_, 'AllowedDoorPairsComponent', get_AllowedDoorPairsComponent);
    defineProp(_, 'AlignmentConnectionsComponent', get_AlignmentConnectionsComponent);
    defineProp(_, 'LightComponent', get_LightComponent);
    defineProp(_, 'RoomDimensionsComponent', get_RoomDimensionsComponent);
    defineProp(_, 'RoomPartComponent', get_RoomPartComponent);
    _.DoorComponent = DoorComponent;
    _.FreeMoveComponent = FreeMoveComponent;
    _.IsDraggedComponent = IsDraggedComponent;
    _.RoomComponent = RoomComponent;
    defineProp(_, 'CoreDebug', get_CoreDebug);
    defineProp(_, 'DynamicProductCatalog', get_DynamicProductCatalog);
    defineProp(_, 'DynamicProduct', get_DynamicProduct);
    defineProp(_, 'ProductTemplate', get_ProductTemplate);
    defineProp(_, 'CatalogTemplateData', get_CatalogTemplateData);
    defineProp(_, 'Part', get_Part);
    defineProp(_, 'ModelRenderInfo', get_ModelRenderInfo);
    defineProp(_, 'DynamicRangeUtils', get_DynamicRangeUtils);
    defineProp(_, 'RelativePosition', get_RelativePosition);
    defineProp(_, 'RelativeTransform', get_RelativeTransform);
    defineProp(_, 'PositionTemplate', get_PositionTemplate);
    defineProp(_, 'OriginRelativeTo', get_OriginRelativeTo);
    defineProp(_, 'PositionType', get_PositionType);
    defineProp(_, 'VisualLightSourceComponent', get_VisualLightSourceComponent);
    defineProp(_, 'TemplateEditorService', get_TemplateEditorService);
    defineProp(_, 'BoundItemTemplate', get_BoundItemTemplate);
    defineProp(_, 'Dimension', get_Dimension);
    defineProp(_, 'Compartment', get_Compartment);
    defineProp(_, 'CatalogGenerator', get_CatalogGenerator);
    _.PositionValue = PositionValue_0;
    _.OriginTemplate = OriginTemplate_0;
    _.getMeta = getMeta;
    defineProp(_, 'Experimental', experimental_js_getInstance_e6vaee);
    defineProp(_, 'IPEXRangeFormatCatalog', get_IPEXRangeFormatCatalog);
    defineProp(_, 'AmendableCatalog', get_AmendableCatalog);
    defineProp(_, 'RangeItemDTO', get_RangeItemDTO);
    defineProp(_, 'StaticComponentBuilder', get_StaticComponentBuilder);
    defineProp(_, 'createCore', get_createCore);
    defineProp(_, 'SceneSerializationUtil', get_SceneSerializationUtil);
    _.Core = Core;
    defineProp(_, 'PlacementService', get_PlacementService);
    defineProp(_, 'ReplaceUtils', get_ReplaceUtils);
    defineProp(_, 'ReplaceAssemblyPartUtils', get_ReplaceAssemblyPartUtils);
    defineProp(_, 'SnapPlacementActor', get_SnapPlacementActor);
    defineProp(_, 'ProppingSystem', get_ProppingSystem);
    defineProp(_, 'ConnectorVisualizationSystem', get_ConnectorVisualizationSystem);
    defineProp(_, 'ColliderVisualizationSystem', get_ColliderVisualizationSystem);
    defineProp(_, 'AutoAdaptHostZoneVisualizationSystem', get_AutoAdaptHostZoneVisualizationSystem);
    defineProp(_, 'FunctionalMarginVisualizationSystem', get_FunctionalMarginVisualizationSystem);
    defineProp(_, 'FunctionalZoneVisualization', get_FunctionalZoneVisualization);
    defineProp(_, 'DragProjectionPointVisualizationSystem', get_DragProjectionPointVisualizationSystem);
    defineProp(_, 'DragSystem', get_DragSystem);
    defineProp(_, 'SnapCardinalDirectionsDragStrategy', get_SnapCardinalDirectionsDragStrategy);
    defineProp(_, 'SnapClosestDragStrategy', get_SnapClosestDragStrategy);
    defineProp(_, 'SnapClosestWithSubConnectorsDragStrategy', get_SnapClosestWithSubConnectorsDragStrategy);
    defineProp(_, 'ResolveCollisionsDragStrategy', get_ResolveCollisionsDragStrategy);
    defineProp(_, 'DrawDragGhostSystem', get_DrawDragGhostSystem);
    defineProp(_, 'DragSurfaceNormalVisualizationSystem', get_DragSurfaceNormalVisualizationSystem);
    defineProp(_, 'DragSurfaceVisualizationSystem', get_DragSurfaceVisualizationSystem);
    defineProp(_, 'DebugLineDrawingSystem', get_DebugLineDrawingSystem);
    defineProp(_, 'StandardSelectionService', get_StandardSelectionService);
    defineProp(_, 'AutoAdaptService', get_AutoAdaptService);
    defineProp(_, 'AlignmentConnectionCreationSystem', get_AlignmentConnectionCreationSystem);
    defineProp(_, 'RoomService', get_RoomService);
    defineProp(_, 'RoomSystem', get_RoomSystem);
    defineProp(_, 'RoomComponentDeserializer', get_RoomComponentDeserializer);
    defineProp(_, 'RoomConnectorConstants', get_RoomConnectorConstants);
    defineProp(_, 'StandardSelectionSystem', get_StandardSelectionSystem);
    defineProp(_, 'OutlineSystem', get_OutlineSystem);
    defineProp(_, 'OutlineSelectedSystem', get_OutlineSelectedSystem);
    defineProp(_, 'OutlineEntityGroupDeselectSystem', get_OutlineEntityGroupDeselectSystem);
    defineProp(_, 'AllowedDoorPairsValidation', get_AllowedDoorPairsValidation);
    defineProp(_, 'AlignmentPlane', get_AlignmentPlane);
    defineProp(_, 'AllowedNumberOfChildrenOfTypeValidation', get_AllowedNumberOfChildrenOfTypeValidation);
    defineProp(_, 'DisallowSeparateRequiredHostsValidation', get_DisallowSeparateRequiredHostsValidation);
    defineProp(_, 'AssemblyInstructionsService', get_AssemblyInstructionsService);
    defineProp(_, 'ICFDataService', get_ICFDataService);
    defineProp(_, 'PlacementResult', get_PlacementResult);
    defineProp(_, 'PlacementResultCompanion', get_PlacementResultCompanion);
    defineProp(_, 'FunctionalMarginValidation', get_FunctionalMarginValidation);
    defineProp(_, 'PlacementZoneValidation', get_PlacementZoneValidation);
    defineProp(_, 'AlignmentLinesSystem', get_AlignmentLinesSystem);
    defineProp(_, 'FunctionalMarginSystem', get_FunctionalMarginSystem);
    defineProp(_, 'FunctionalMarginShapeComponent', get_FunctionalMarginShapeComponent);
    defineProp(_, 'FunctionalMarginComponent', get_FunctionalMarginComponent);
    defineProp(_, 'RecommendedInitialPositionFromFloorComponent', get_RecommendedInitialPositionFromFloorComponent);
    defineProp(_, 'PlacementZoneByHeightComponent', get_PlacementZoneByHeightComponent);
    defineProp(_, 'StlSystemIds', get_StlSystemIds);
    defineProp(_, 'ReplacePartResult', get_ReplacePartResult);
    defineProp(_, 'AnyDragSurfaceProjector', get_AnyDragSurfaceProjector);
    defineProp(_, 'XYPlaneProjector', get_XYPlaneProjector);
    defineProp(_, 'DragSurfaceCanHostSelector', get_DragSurfaceCanHostSelector);
    defineProp(_, 'DragSurfaceCanHostWithAutoAdaptSelector', get_DragSurfaceCanHostWithAutoAdaptSelector);
    defineProp(_, 'AutoAdaptProductSpecificationsSystem', get_AutoAdaptProductSpecificationsSystem);
    defineProp(_, 'LegacyCanvasTo3DDragConverterSystem', get_LegacyCanvasTo3DDragConverterSystem);
    defineProp(_, 'CanvasTo3DDragConverterSystem', get_CanvasTo3DDragConverterSystem);
    defineProp(_, 'EntityConnectorVisualizationSystem', get_EntityConnectorVisualizationSystem);
    defineProp(_, 'EntityConnectorVisualizationComponent', get_EntityConnectorVisualizationComponent);
    defineProp(_, 'Color', get_Color);
    defineProp(_, 'DefaultVisualizer', get_DefaultVisualizer);
    defineProp(_, 'EntityColliderVisualizationSystem', get_EntityColliderVisualizationSystem);
    defineProp(_, 'EntityColliderVisualizationComponent', get_EntityColliderVisualizationComponent);
    defineProp(_, 'EntityCollisionVisualizationSystem', get_EntityCollisionVisualizationSystem);
    defineProp(_, 'DecoratorComponent', get_DecoratorComponent);
    defineProp(_, 'CoreVisualization', get_CoreVisualization);
    defineProp(_, 'ColoredOutlineSystem', get_ColoredOutlineSystem);
    defineProp(_, 'ColoredOutlineComponent', get_ColoredOutlineComponent);
    defineProp(_, 'DragExtensions', get_DragExtensions);
    defineProp(_, 'AutoAdaptFeature', get_AutoAdaptFeature);
    defineProp(_, 'AutoAdaptUtils', get_AutoAdaptUtils);
    defineProp(_, 'AutoAdaptSessionComponent', get_AutoAdaptSessionComponent);
    defineProp(_, 'DragProjectionPointComponent', get_DragProjectionPointComponent);
    defineProp(_, 'FunctionalZone', get_FunctionalZone);
    defineProp(_, 'FunctionalZonesLocalComponent', get_FunctionalZonesLocalComponent);
    defineProp(_, 'DragState', get_DragState);
    defineProp(_, 'DragStateComponent', get_DragStateComponent);
    defineProp(_, 'ReplaceEntityEventComponent', get_ReplaceEntityEventComponent);
    defineProp(_, 'LabelComponent', get_LabelComponent);
    defineProp(_, 'HigherPriorityAlignmentPostProcess', get_HigherPriorityAlignmentPostProcess);
    defineProp(_, 'ValidationResultIds', get_ValidationResultIds);
    defineProp(_, 'RequiredConnectorsSatisfiedValidation', get_RequiredConnectorsSatisfiedValidation);
    defineProp(_, 'ValidationRuleIds', get_ValidationRuleIds);
    defineProp(_, 'HostConnectorRotationValidation', get_HostConnectorRotationValidation);
    defineProp(_, 'SnapSorterBuilder', get_SnapSorterBuilder);
    defineProp(_, 'PlacementHelper', get_PlacementHelper);
    defineProp(_, 'SpaceFinderUtils', get_SpaceFinderUtils);
    _.ValidDragStrategyResult = ValidDragStrategyResult_0;
    _.AutoAdaptDragStrategy = AutoAdaptDragStrategy_0;
    _.HandleRotationSystem = HandleRotationSystem_0;
    _.DebugLogger = DebugLogger_0;
    _.FunctionalZonesLocalToWorldSystem = FunctionalZonesLocalToWorldSystem_0;
    defineProp(_, 'arrangeExtensions', get_arrangeExtensions);
    defineProp(_, 'placementExtensions', get_placementExtensions);
    defineProp(_, 'autoAdaptExtensions', get_autoAdaptExtensions);
    defineProp(_, 'CountSystem', get_CountSystem);
    defineProp(_, 'RoomGeneratorUtils', get_RoomGeneratorUtils);
  }
  $jsExportAll$(_);
  kotlin_core_core_api.$jsExportAll$(_);
  kotlin_core_core_kernel.$jsExportAll$(_);
  kotlin_core_core_stl.$jsExportAll$(_);
  kotlin_core_core_experimental.$jsExportAll$(_);
  kotlin_core_core_range_dynamic_range.$jsExportAll$(_);
  kotlin_core_ipex_range_format.$jsExportAll$(_);
  kotlin_core_core_test_test_helpers.$jsExportAll$(_);
  //endregion
  return _;
}));

//# sourceMappingURL=core.js.map
